<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/controlled-input.html" name="c-controlled-input">
<link rel="ractive" href="../components/location-input.html" name="c-location-input">
<link rel="ractive" href="../components/controlled-textarea.html" name="c-controlled-textarea">
<link rel="ractive" href="../components/tags-input.html" name="c-tags-input">
<link rel="ractive" href="../components/results-controls.html" name="c-gp-results-controls">
<link rel="ractive" href="../components/results-raw-output.html" name="c-gp-results-raw-output">
<link rel="ractive" href="../components/results-table-output.html" name="c-gp-results-table-output">
<link rel="ractive" href="../components/results-share.html" name="c-gp-results-share">
<link rel="ractive" href="../components/credits-message.html" name="c-gp-credits-message">
<link rel="ractive" href="../components/credits.html" name="c-gp-credits">
<link rel="ractive" href="../components/jumbotron.html" name="c-gp-jumbotron">
<link rel="ractive" href="../components/test-examples.html" name="c-test-examples">
<link rel="ractive" href="../components/video-modal.html" name="c-gp-video-modal">

<r-page
	noYield="{{noYield}}"
	title="{{title}}"
	description="{{description}}"
	openGraphImage="{{#if measurement}}{{@shared.serverHost}}/open-graph/image/measurement/{{measurement}}{{/if}}"
>
	<script src="https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.umd.min.js"></script>

	{{#if !@shared.isServer && !@shared.googleMapsLoaded}}
		<script>
			function onDocumentReady (fn) {
				if (document.readyState !== 'loading') {
					fn();
				} else {
					document.addEventListener('DOMContentLoaded', fn);
				}
			}
			/* eslint-disable */
			function initMap () {
				onDocumentReady(function () {
					app.loaded = true;

					if (app.router.route && app.router.route.view && app.router.route.view.initMap) {
						app.router.route.view.initMap();
					}
				});
			}
		</script>
		<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&amp;language=en&amp;callback=initMap&libraries=marker&loading=async" async></script>
	{{/if}}

	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-globalping-bg no-border"></c-gp-header>

	<div class="p-globalping">
		<c-gp-jumbotron className="main" gridType="globe"></c-gp-jumbotron>

		<div class="gp_main-info">
			<div class="gp_main-info_descr">
				<span class="gp_main-info_descr_green">Monitor, debug and benchmark</span>
				<span>your internet infrastructure from a globally distributed network of probes.</span>
			</div>

			<div class="gp_main-info_row">
				<div class="gp_main-info_stats">
					<a href="/network?group=disabled" class="gp_main-info_stats_item" aria-label="Explore the network">
					<span class="gp_main-info_stats_item_number">
						{{ Math.floor(totalProbes) }}
						<span></span>
					</span>
						<span class="gp_main-info_stats_item_text">connected probes</span>
					</a>

					<a href="/network" class="gp_main-info_stats_item" aria-label="Explore the network">
					<span class="gp_main-info_stats_item_number">
						{{ Math.floor(totalCities) }}
						<span></span>
					</span>
						<span class="gp_main-info_stats_item_text">different cities</span>
					</a>

					<a href="/network?group=country" class="gp_main-info_stats_item" aria-label="Explore the network">
					<span class="gp_main-info_stats_item_number">
						{{ Math.floor(totalCountries) }}
						<span></span>
					</span>
						<span class="gp_main-info_stats_item_text">different countries</span>
					</a>
				</div>

				<c-gp-video-modal view="{{view}}"></c-gp-video-modal>
			</div>
		</div>

		<div class="gp_map-block">
			<div class="gp_map-block_header">
				<span></span>
				<span></span>
				<span></span>
				{{#if shareResHeaderData}}
					<span class="gp_map-block_header_share-res-msg">{{shareResHeaderData}}</span>
				{{/if}}
			</div>

			<div class="gp_map-block_settings-wrapper">
				<div class="gp_map-block_settings-wrapper_settings">
					<div class="gp_map-block_settings-wrapper_settings_grouped">
						<div class="gp_dropdown_reg">
							<span>Test type</span>

							<div class="btn-group">
								<button type="button"
									class="dropdown-toggle {{#if testInProgress}}disabled{{/if}}"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false">
									<span>{{~/mainOptions.type}}</span>
									<i class="fa fa-angle-down" aria-hidden="true"></i>
								</button>

								<ul role="listbox" class="dropdown-menu">
									{{#each ~/testTypesList}}
										<li aria-selected="{{this === mainOptions.type}}"
											role="option"
											on-click="@this.setMainOptsTestType(this)">
											{{this}}
										</li>
									{{/each}}
								</ul>
							</div>
						</div>

						<c-tags-input
							inputId="targetInput"
							value="{{mainOptions.target}}"
							defaultValue="{{DEFAULT_TARGET_VALUE}}"
							error="{{inputErrors.target}}"
							placeholder="IP or domain"
							labelText="Target(s)"
							isDisabled="{{testInProgress}}"
							setDefaultValueInitially="{{!shareResFlow}}"
							useGpTargetHandler="{{true}}"
							gpMainOpts="{{mainOptions}}"
							gpHttpOpts="{{httpOpts}}"
							gpNotAppliedOpts="{{notAppliedOpts}}"
							gpUrlHandlerCb="{{@this.applyOptions}}"
							showIPSwitch="{{mainOptions.type !== 'DNS'}}"
							ipVersion="{{mainOptions.ipVersion}}"
							ttPos="{{ttPositions.targetTtPos}}">
							{{#partial labelIcon}}
								<img as-tooltip="'Up to 2 IP addresses or domains', ttPos"
									width="14"
									height="14"
									src="{{@shared.assetsHost}}/img/help-icon.svg">
							{{/partial}}
						</c-tags-input>
					</div>

					<div class="gp_map-block_settings-wrapper_settings_grouped">
						<c-location-input
							on-enter="@this.resetMapAndRunTest()"
							rawProbes="{{rawProbes}}"
							value="{{mainOptions.location}}"
							error="{{inputErrors.location}}"
							placeholder="Enter location"
							labelText="Location"
							classList="gp_map-block_settings-wrapper_settings_location gp_input location-input-hp"
							disabled="{{testInProgress}}"
							ttPos="{{ttPositions.locationTtPos}}"
							locationAutofilled="{{locationAutofilled}}">
							{{#partial labelIcon}}
								<img as-tooltip="[ 'This magic field supports names of continents, regions, countries, US states, cities, networks, and our custom tags.', '', 'Use + to combine multiple filters.', 'Use , to select multiple locations.' ], ttPos, undefined, undefined, 'multiline'"
									width="14"
									height="14"
									src="{{@shared.assetsHost}}/img/help-icon.svg">
							{{/partial}}
						</c-location-input>

						<div class="gp_map-block_settings-wrapper_settings_subgroup">
							<c-controlled-input
								id="limitInput"
								value="{{mainOptions.limit}}"
								error="{{inputErrors.limit}}"
								placeholder="{{defaultLimit}}"
								labelText="Limit"
								classList="gp_map-block_settings-wrapper_settings_limit gp_input"
								hideLabelIcon="{{infiniteSwitchEnabled === false}}"
								disabled="{{testInProgress}}"
								ttPos="{{ttPositions.limitTtPos}}">
								{{#partial labelIcon}}
									<img as-tooltip="'Values up to 5 are supported for infinite measurements', ttPos, undefined, undefined, 'gp_tt-limit'"
										width="14"
										height="14"
										src="{{@shared.assetsHost}}/img/help-icon.svg">
								{{/partial}}
							</c-controlled-input>

							<div class="gp_map-block_settings-wrapper_settings_subgroup_options-block {{#if testInProgress}}disabled{{/if}}">
								<button class="{{#if showMeasurementOpts}}active{{/if}}"
									on-click="@this.handleToggleMeasOpts()">
									<img width="20"
										height="20"
										src="{{@shared.assetsHost}}/img/settings-icon.svg">

									{{#if modifiedMeasOptsCnt && showMeasurementOpts === false}}
										<div class="additional-opts-total">
											{{modifiedMeasOptsCnt}}
										</div>
									{{/if}}
								</button>

								<div class="gp_map-block_settings-wrapper_settings_subgroup_options-block_specific-set shadow-md-light">
									{{#if mainOptions.type === 'ping'}}
										<div class="typePing">
											<div class="pair">
												<c-controlled-input
													value="{{notAppliedOpts.port}}"
													error="{{inputErrors.port}}"
													placeholder="80"
													labelText="Port"
													classList="port-input gp_input"
													disabled="{{disablePort}}">
												</c-controlled-input>

												<div class="gp_dropdown_reg">
													<span>Protocol</span>

													<div class="btn-group">
														<button type="button"
																class="dropdown-toggle"
																data-toggle="dropdown"
																aria-haspopup="true"
																aria-expanded="false">
															<span>{{~/pingOpts.protocol}}</span>
															<i class="fa fa-angle-down" aria-hidden="true"></i>
														</button>

														<ul role="listbox" class="dropdown-menu">
															<li aria-selected="{{pingOpts.protocol === 'TCP'}}"
																role="option"
																on-click="@this.set('pingOpts.protocol', 'TCP')">
																TCP
															</li>
															<li aria-selected="{{pingOpts.protocol === 'ICMP'}}"
																role="option"
																on-click="@this.set('pingOpts.protocol', 'ICMP')">
																ICMP
															</li>
														</ul>
													</div>
												</div>
											</div>

											<c-controlled-input
												value="{{notAppliedOpts.packets}}"
												error="{{inputErrors.packets}}"
												placeholder="{{defaultPacketsAmount}}"
												labelText="Packets"
												classList="gp_input"
												disabled="{{infiniteSwitchEnabled}}">
											</c-controlled-input>
										</div>
									{{/if}}

									{{#if mainOptions.type === 'traceroute'}}
										<div class="typeTraceroute">
											<div class="pair">
												<c-controlled-input
													value="{{notAppliedOpts.port}}"
													error="{{inputErrors.port}}"
													placeholder="53"
													labelText="Port"
													classList="port-input gp_input"
													disabled="{{disablePort}}">
												</c-controlled-input>

												<div class="gp_dropdown_reg">
													<span>Protocol</span>

													<div class="btn-group">
														<button type="button"
															class="dropdown-toggle"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false">
															<span>{{~/tracerouteOpts.protocol}}</span>
															<i class="fa fa-angle-down" aria-hidden="true"></i>
														</button>

														<ul role="listbox" class="dropdown-menu">
															<li role="option"
																aria-selected="{{tracerouteOpts.protocol === 'TCP'}}"
																on-click="@this.set('tracerouteOpts.protocol', 'TCP')">
																TCP
															</li>
															<li role="option"
																aria-selected="{{tracerouteOpts.protocol === 'UDP'}}"
																on-click="@this.set('tracerouteOpts.protocol', 'UDP')">
																UDP
															</li>
															<li role="option"
																aria-selected="{{tracerouteOpts.protocol === 'ICMP'}}"
																on-click="@this.set('tracerouteOpts.protocol', 'ICMP')">
																ICMP
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									{{/if}}

									{{#if mainOptions.type === 'DNS'}}
										<div class="typeDNS">
											<div class="rows">
												<div class="rows_row-one">
													<c-controlled-input
														value="{{notAppliedOpts.port}}"
														error="{{inputErrors.port}}"
														placeholder="53"
														labelText="Port"
														classList="port-input gp_input">
													</c-controlled-input>

													<div class="gp_dropdown_reg">
														<span>Protocol</span>

														<div class="btn-group">
															<button type="button"
																class="dropdown-toggle"
																data-toggle="dropdown"
																aria-haspopup="true"
																aria-expanded="false">
																<span>{{~/dnsOpts.protocol}}</span>
																<i class="fa fa-angle-down" aria-hidden="true"></i>
															</button>

															<ul role="listbox" class="dropdown-menu">
																<li aria-selected="{{dnsOpts.protocol === 'UDP'}}"
																	role="option"
																	on-click="@this.set('dnsOpts.protocol', 'UDP')">
																	UDP
																</li>
																<li aria-selected="{{dnsOpts.protocol === 'TCP'}}"
																	role="option"
																	on-click="@this.set('dnsOpts.protocol', 'TCP')">
																	TCP
																</li>
															</ul>
														</div>
													</div>
												</div>

												<div class="rows_row-two">
													<div class="gp_dropdown_reg">
														<span>Type</span>

														<div class="btn-group">
															<button type="button"
																class="dropdown-toggle"
																data-toggle="dropdown"
																aria-haspopup="true"
																aria-expanded="false">
																<span>{{~/dnsOpts.query.type}}</span>
																<i class="fa fa-angle-down" aria-hidden="true"></i>
															</button>

															<ul role="listbox" class="dropdown-menu">
																{{#each ~/dnsTypesList}}
																	<li aria-selected="{{this === dnsOpts.query.type}}"
																		role="option"
																		on-click="@this.set('dnsOpts.query.type', this)">
																		{{this}}
																	</li>
																{{/each}}
															</ul>
														</div>
													</div>

													<div class="rows_row-two_switch-block">
														<label class="gp_switch">
															<input type="checkbox" on-click="@this.set('dnsOpts.trace', !dnsOpts.trace)" checked="{{dnsOpts.trace}}">
															<span class="slider round"></span>
														</label>

														<span>Trace</span>
													</div>
												</div>
											</div>

											<c-controlled-input
												value="{{notAppliedOpts.resolver}}"
												error="{{inputErrors.resolver}}"
												placeholder="IP address"
												labelText="Resolver"
												classList="resolver-input gp_input">
											</c-controlled-input>
										</div>
									{{/if}}

									{{#if mainOptions.type === 'MTR'}}
										<div class="typeMTR">
											<div class="pair">
												<c-controlled-input
													value="{{notAppliedOpts.port}}"
													error="{{inputErrors.port}}"
													placeholder="53"
													labelText="Port"
													classList="port-input gp_input"
													disabled="{{disablePort}}">
												</c-controlled-input>

												<div class="gp_dropdown_reg">
													<span>Protocol</span>

													<div class="btn-group">
														<button type="button"
															class="dropdown-toggle"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false">
															<span>{{~/mtrOpts.protocol}}</span>
															<i class="fa fa-angle-down" aria-hidden="true"></i>
														</button>

														<ul role="listbox" class="dropdown-menu">
															<li aria-selected="{{mtrOpts.protocol === 'UDP'}}"
																role="option"
																on-click="@this.set('mtrOpts.protocol', 'UDP')">
																UDP
															</li>
															<li aria-selected="{{mtrOpts.protocol === 'TCP'}}"
																role="option"
																on-click="@this.set('mtrOpts.protocol', 'TCP')">
																TCP
															</li>
															<li aria-selected="{{mtrOpts.protocol === 'ICMP'}}"
																role="option"
																on-click="@this.set('mtrOpts.protocol', 'ICMP')">
																ICMP
															</li>
														</ul>
													</div>
												</div>
											</div>

											<c-controlled-input
												value="{{notAppliedOpts.packets}}"
												error="{{inputErrors.packets}}"
												placeholder="{{defaultPacketsAmount}}"
												labelText="Packets"
												classList="gp_input">
											</c-controlled-input>
										</div>
									{{/if}}

									{{#if mainOptions.type === 'HTTP'}}
										<div class="typeHTTP">
											<c-controlled-input
												value="{{notAppliedOpts.request.host}}"
												error="{{inputErrors.host}}"
												placeholder="Host"
												labelText="Host"
												classList="gp_input">
											</c-controlled-input>

											<c-controlled-input
												value="{{notAppliedOpts.request.path}}"
												error="{{inputErrors.path}}"
												placeholder="Path"
												labelText="Path"
												classList="gp_input">
											</c-controlled-input>

											<c-controlled-input
												value="{{notAppliedOpts.request.query}}"
												error="{{inputErrors.query}}"
												placeholder="Query"
												labelText="Query"
												classList="gp_input">
											</c-controlled-input>

											<div class="pair">
												<div class="gp_dropdown_reg">
													<span>Protocol</span>

													<div class="btn-group">
														<button type="button"
															class="dropdown-toggle"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false">
															<span>{{~/httpOpts.protocol}}</span>
															<i class="fa fa-angle-down" aria-hidden="true"></i>
														</button>

														<ul role="listbox" class="dropdown-menu">
															<li aria-selected="{{httpOpts.protocol === 'HTTP'}}"
																role="option"
																on-click="@this.set('httpOpts.protocol', 'HTTP')">
																HTTP
															</li>
															<li aria-selected="{{httpOpts.protocol === 'HTTPS'}}"
																role="option"
																on-click="@this.set('httpOpts.protocol', 'HTTPS')">
																HTTPS
															</li>
															<li aria-selected="{{httpOpts.protocol === 'HTTP2'}}"
																role="option"
																on-click="@this.set('httpOpts.protocol', 'HTTP2')">
																HTTP2
															</li>
														</ul>
													</div>
												</div>

												<c-controlled-input
													value="{{notAppliedOpts.port}}"
													error="{{inputErrors.port}}"
													placeholder="53"
													labelText="Port"
													classList="port-input gp_input">
												</c-controlled-input>
											</div>

											<div class="pair">
												<div class="gp_dropdown_reg">
													<span>Method</span>

													<div class="btn-group">
														<button type="button"
															class="dropdown-toggle"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false">
															<span>{{~/httpOpts.request.method}}</span>
															<i class="fa fa-angle-down" aria-hidden="true"></i>
														</button>

														<ul role="listbox" class="dropdown-menu">
															<li aria-selected="{{httpOpts.request.method === 'GET'}}"
																role="option"
																on-click="@this.set('httpOpts.request.method', 'GET')">
																GET
															</li>
															<li aria-selected="{{httpOpts.request.method === 'HEAD'}}"
																role="option"
																on-click="@this.set('httpOpts.request.method', 'HEAD')">
																HEAD
															</li>
															<li aria-selected="{{httpOpts.request.method === 'OPTIONS'}}"
																role="option"
																on-click="@this.set('httpOpts.request.method', 'OPTIONS')">
																OPTIONS
															</li>
														</ul>
													</div>
												</div>

												<c-controlled-input
													value="{{notAppliedOpts.resolver}}"
													error="{{inputErrors.resolver}}"
													placeholder="Resolver"
													labelText="Resolver"
													classList="gp_input">
												</c-controlled-input>
											</div>

											<c-controlled-textarea
												value="{{notAppliedOpts.request.headers}}"
												error="{{inputErrors.headers}}"
												placeholder="Header: Value"
												labelText="Headers"
												classList="gp_input">
											</c-controlled-textarea>

											{{#if inputErrors.request}}
												<span class="c-controlled-input_error" role="alert">{{inputErrors.request}}</span>
											{{/if}}
										</div>
									{{/if}}

									<button class="gp_btn_green" on-click="@this.applyOptions()">
										Apply
									</button>
								</div>
							</div>

							<div class="gp_map-block_settings-wrapper_settings_subgroup_switch-block {{#unless @this.isInfiniteOptsCorrect()}}turned-off{{/unless}} {{#if testInProgress}}disabled{{/if}}">
								<label class="gp_switch">
									<input type="checkbox"
										checked="{{infiniteSwitchEnabled}}"
										on-click="@this.handleInfiniteSwitch()"
										on-keydown="@this.handleInfiniteSwitchKeyDown(@event)"
										{{#unless @this.isInfiniteOptsCorrect() && !testInProgress}}disabled="true"{{/unless}}>
									<span class="slider round"></span>
								</label>

								<span>Infinite</span>
							</div>
						</div>
					</div>
				</div>

				<div id="dd-run-test-btn" class="btn-group run-test-btn">
					{{#if prevProbesMeasId && !testInProgress}}
						<div class="gp_map-block_settings-wrapper_split-btn">
							<button disabled="{{runTestBtnDisabled}}" class="gp_map-block_settings-wrapper_split-btn_run gp_btn_green" on-click="@this.handleRunTestBtn()">
								Run
							</button>

							<button type="button"
								class="dropdown-toggle gp_btn_green"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
								disabled="{{runTestBtnDisabled}}">
									<div class="gp_map-block_settings-wrapper_split-btn_icon">
										<img width="20" height="20" src="{{@shared.assetsHost}}/img/chevron-down.white.svg">
									</div>
							</button>

							<div class="dropdown-menu gp_map-block_settings-wrapper_split-btn_dropdown">
								<span class="dropdown-item" on-click="@this.reUseProbesRunTest()">Re-use probes</span>
							</div>
						</div>
					{{else}}
						<button on-click="@this.handleRunTestBtn()"
							class="gp_map-block_settings-wrapper_btn {{#if !testInProgress}}gp_btn_green{{else}}gp_btn_black gp_btn_black_loading{{/if}} {{#if !testInProgress && !gmapsReady}}gp_btn_green_disabled{{/if}}"
							data-testid="run-test-btn"
							disabled="{{runTestBtnDisabled}}">
							{{#if testInProgress}}
								<span>Stop</span>
								<div class="spinner">
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							{{else}}
								{{runTestBtnText}}
							{{/if}}
						</button>
					{{/if}}
				</div>
			</div>

			{{#if showCreditsErrorBar}}
				<c-gp-credits-message
					measurementErrMsg="{{measurementErrMsg}}"
					rateCreditsData="{{rateCreditsData}}">
				</c-gp-credits-message>
			{{/if}}

			{{#if mobileShareResHeaderData}}
				<p class="gp_map-block_test-details">
					<i class="fa fa-info-circle" aria-hidden="true"></i>
					Showing <strong>{{mobileShareResHeaderData.type}}</strong> test results for <strong>{{mobileShareResHeaderData.target}}</strong> from {{mobileShareResHeaderData.date}}.
				</p>
			{{/if}}

			<div class="gp_map-block_map-wrapper {{#unless transitionMap}}transition-none{{/unless}} {{#unless showMap}}gp_map-block_map-wrapper_hidden{{/unless}}">
				<div id="gp-map" class="gp_map-block_map-wrapper_map"></div>

				{{#if testResults}}
					<div class="gp_map-block_map-wrapper_timings-scale">
						<span class="value">{{probesMaxTiming}} ms</span>
						<div class="gradient"></div>
						<span class="value">{{probesMinTiming}} ms</span>
					</div>
				{{/if}}
			</div>

			{{#if showCreditsData}}
				<c-gp-credits
					mapOpened="{{showMap}}"
					testInProgress="{{testInProgress}}"
					isInfiniteModeRes="{{isInfiniteModeRes}}"
					rateCreditsData="{{rateCreditsData}}"
					testResults="{{testResults}}">
				</c-gp-credits>
			{{/if}}

			{{#if measurementErrMsg && !showCreditsErrorBar}}
				<div class="gp_map-block_test-output with-padding">
					<div class="gp_map-block_test-output_fail-msg">
						<img width="56"
							height="56"
							src="{{@shared.assetsHost}}/img/fail-icon-big.svg">

						<p>{{{measurementErrMsg}}}</p>
					</div>
				</div>
			{{elseif testResults && (rawOutputMode || tableOutputReady)}}
				<div class="gp_map-block_test-output">
					<c-gp-results-controls
						showMap="{{showMap}}"
						originalShowMap="{{originalShowMap}}"
						targets="{{targetsArr}}"
						activeTargetIdx="{{activeTargetIdx}}"
						rawOutputMode="{{rawOutputMode}}"
						collapseOutput="{{@this.collapseAllRawOutput}}"
						expandOutput="{{@this.expandAllRawOutput}}"
						allCollapsed="{{allCollapsed}}"
						sortOrder="{{sortOrder}}"
						sortBy="{{sortBy}}"
						sortByOpts="{{sortByOpts}}"
					>
					</c-gp-results-controls>

					{{#if rawOutputMode}}
						<div class="gp_map-block_test-output_raw-output">
							<c-gp-results-raw-output
								testReqParams="{{testReqParams}}"
								preparedTestResults="{{preparedTestResults}}"
								hiddenTestResults="{{hiddenTestResults}}"
								hiddenResponseBodies="{{hiddenResponseBodies}}"
								testInProgress="{{testInProgress}}"
								isTestStopped="{{isTestStopped}}"
								scrolledToResId="{{scrolledToResId}}"
								currSearchLocation="{{mainOptions.location}}"
								measurementsMetadata="{{measurementsMetadata}}"
								activeTargetIdx="{{activeTargetIdx}}"
								targetsCnt="{{targetsArr.length}}"
								isInfiniteModeRes="{{isInfiniteModeRes}}"
								screenWidth="{{screenWidth}}"
								sortOrder="{{sortOrder}}"
								sortBy="{{sortBy}}"
								showingNetworkLogos="{{showingNetworkLogos}}"
								responseBodyCharWidth="{{responseBodyCharWidth}}"
								expandAllRawOutput="{{@this.expandAllRawOutput}}">
							</c-gp-results-raw-output>
						</div>
					{{else}}
						<div class="gp_map-block_test-output_table-output">
							<c-gp-results-table-output
								testReqParams="{{testReqParams}}"
								testType="{{testReqParams.type}}"
								testInProgress="{{testInProgress}}"
								preparedTestResults="{{preparedTestResults}}"
								tableColumns="{{tableColumns}}"
								targetsCnt="{{targetsArr.length}}"
								currSearchLocation="{{mainOptions.location}}"
								measurementsMetadata="{{measurementsMetadata}}"
								isInfiniteModeRes="{{isInfiniteModeRes}}"
								sortOrder="{{sortOrder}}"
								sortBy="{{sortBy}}">
							</c-gp-results-table-output>
						</div>
					{{/if}}

				</div>
			{{else}}
				<div class="gp_map-block_test-output with-padding">
					<div class="gp_map-block_test-output_info">
						<div class="gp_map-block_test-output_info_text">
							<img width="56"
								height="56"
								src="{{@shared.assetsHost}}/img/bulb-icon.svg">

							<p>
								Run a global latency test! Benchmark your CDN provider and understand how the network performs!
								Compare DNS providers to find the fastest one globally or in your region.
								Run network tests globally or from specific locations and regions.
								Debug and troubleshoot your networking problems and share the test results with others!
							</p>
						</div>
						<c-test-examples onExampleClick="{{@this.onExampleClick}}"></c-test-examples>
					</div>
				</div>
			{{/if}}
			{{#if testInProgress || testReqParams.id}}
				<c-gp-results-share
					testReqParams="{{testReqParams}}"
					measurementsMetadata="{{measurementsMetadata}}"
					realTimeTestResResponse="{{realTimeTestResResponse}}"
					expectedTargetsCnt="{{targetsArr.length || qsMeasurementIdsArr.length}}"
					isInfiniteModeRes="{{isInfiniteModeRes}}"
					isTestStopped="{{isTestStopped}}"
					testInProgress="{{testInProgress}}"
					preparedTestResults="{{preparedTestResults}}"
					activeTargetIdx="{{activeTargetIdx}}">
				</c-gp-results-share>
			{{/if}}
			{{#if rawOutputMode && showingNetworkLogos}}
				<a class="gp_map-block_logo-dev-link" href="https://logo.dev" target="_blank" rel="noopener noreferrer">Network logos provided by Logo.dev</a>
			{{/if}}
		</div>

		<div class="gp_details">
			<div class="gp_details_platform">
				<div class="gp_details_platform_title">The Globalping platform</div>
				<div class="gp_details_platform_descr">
					Globalping is a platform that allows anyone to run networking commands such as ping, traceroute,
					dig, curl and mtr on probes distributed all around the world. Our goal is to provide a free and simple
					service for everyone out there to make the internet faster. You can use it to optimize your anycast
					network, monitor your latency, debug routing issues and even check for censorship in different countries.
				</div>
				<img class="gp_details_platform_img"
					width="363"
					height="288"
					alt=""
					src="{{@shared.assetsHost}}/img/polygons_1.svg">
			</div>

			<div class="gp_details_magic">
				<div class="gp_details_magic_title">Test from anywhere with <span class="text-magic-color">magic</span></div>
				<div class="gp_details_magic_descr">
					All Globalping integrations and tools including the CLI <a target="_blank" rel="noreferrer" href="https://github.com/jsdelivr/globalping#best-practices-and-tips">use the magic API field</a> to set the location of a test.
					This means that you can write anything that makes sense to you as the input and we will do our best to select the
					most appropriate probes. Valid inputs include countries, continents, cities, US states, regions
					(Western Europe), ASNs, ISP names, eyeball or datacenter tags and cloud region names (us-east-2).
				</div>
				<img class="gp_details_magic_img"
					width="510"
					height="289"
					alt=""
					src="{{@shared.assetsHost}}/img/polygons_2.svg">
			</div>
		</div>

		<section class="gp_integrations">
			<div class="gp_integrations_content">
				<div class="gp_integrations_background-container">
					<img src="{{@shared.assetsHost}}/img/polygons_5.svg" class="gp_integrations_background" alt="">
				</div>
				<div class="gp_integrations_main">
					<h4 class="gp_integrations_header">Integrations</h4>
					<p class="gp_integrations_description">A fully-featured REST API for your own app, easy-to-use CLI for scripting, or a no-code chatbot – we have it all. Integrate Globalping into anything!</p>
					<a class="gp_integrations_link" href="/integrations">Check our integrations</a>
				</div>
				<div class="gp_integrations_examples">
					{{#each integrationExamples}}
						<div class="gp_integrations_example">
							<img class="gp_integrations_example_logo" src="{{@shared.assetsHost}}{{this.img}}" height="48" width="48" alt="">
							<div>
								<h5 class="gp_integrations_example_header">
									{{this.name}}
								</h5>
								<p class="gp_integrations_example_description">
									{{this.description}}
								</p>
							</div>
						</div>
					{{/each}}
				</div>
			</div>
		</section>

		<div class="gp_features">
			<div class="gp_features_item">
				<span class="gp_features_item_icon">
					<img width="48"
						height="48"
						src="{{@shared.assetsHost}}/img/globalping-opensource-icon.svg">
				</span>
				<span class="gp_features_item_name">
					Open source and free
				</span>
				<span class="gp_features_item_descr">
					Every component of Globalping is open source and is being actively developed on GitHub with the help of our community and users. We offer generous free limits with higher limits for GitHub Sponsors.
				</span>
			</div>

			<div class="gp_features_item">
				<span class="gp_features_item_icon">
					<img width="48"
						height="48"
						src="{{@shared.assetsHost}}/img/globalping-nonprofit-icon.svg">
					</span>
				<span class="gp_features_item_name">
					Developed by jsDelivr
				</span>
				<span class="gp_features_item_descr">
					The Globalping platform is developed by the jsDelivr team who has more than 10 years of experience maintaining the jsDelivr CDN which is being used by millions of websites around the globe.
				</span>
			</div>

			<div class="gp_features_item">
				<span class="gp_features_item_icon">
					<img width="48"
						height="48"
						src="{{@shared.assetsHost}}/img/globalping-community-icon.svg">
					</span>
				<span class="gp_features_item_name">
					Powered by community and sponsors
				</span>
				<span class="gp_features_item_descr">
					The jsDelivr organization and all projects including Globalping rely on our corporate and individual sponsors. Consider joining them to help us release new features even faster!
				</span>
			</div>

			<div class="gp_features_item">
				<span class="gp_features_item_icon">
					<img width="48"
						height="48"
						src="{{@shared.assetsHost}}/img/globalping-security-icon.svg">
				</span>
				<span class="gp_features_item_name">
					Secure and private
				</span>
				<span class="gp_features_item_descr">
					The security of our systems and privacy of our users are of the utmost importance for us. We minimize the public information that our probes expose and block harmful and abusive domains and IPs.
				</span>
			</div>
		</div>

		<div class="gp_installation">
			<a href="/cli" class="gp_installation_item">
				<img width="61"
					height="53"
					src="{{@shared.assetsHost}}/img/cli-icon.svg">

				<span class="gp_installation_item_title">
					Install the Globalping CLI
				</span>

				<span class="gp_installation_item_descr">
					Run and script network tests from all over the world without ever leaving your terminal
				</span>
			</a>

			<a href="/docs/api.globalping.io" class="gp_installation_item router-ignore">
				<img width="61"
					height="53"
					src="{{@shared.assetsHost}}/img/rest-api-icon.svg">

				<span class="gp_installation_item_title">
					Integrate the Globalping REST API
				</span>

				<span class="gp_installation_item_descr">
					Use our free API to build your own tools, automated your tests and integrate Globalping into your existing flow
				</span>
			</a>

			<a href="/slack" class="gp_installation_item">
				<img width="61"
					height="53"
					src="{{@shared.assetsHost}}/img/slack-icon.svg">

				<span class="gp_installation_item_title">
					Install the Globalping Slack App
				</span>

				<span class="gp_installation_item_descr">
					Install the app into your Slack organization to allow all of your members to run global tests in any channel
				</span>
			</a>
		</div>

		<div class="gp_our-users">
			<div class="gp_our-users_title">Our users:</div>
			<div class="gp_our-users_list">
				<div class="gp_our-users_list_user">
					<a target="_blank" rel="noopener noreferrer" href="https://www.fastly.com">
						<img title="Used by Fastly"
							height="48"
							src="{{@shared.assetsHost}}/img/sponsors/fastly.png"
							srcset="{{@shared.assetsHost}}/img/sponsors/fastly@2x.png 2x"
							loading="lazy">
					</a>
				</div>

				<div class="gp_our-users_list_user">
					<a target="_blank" rel="noopener noreferrer" href="https://he.net">
						<img title="Used by Hurricane Electric"
							height="48"
							src="{{@shared.assetsHost}}/img/sponsors/hurricane_electric.png"
							loading="lazy">
					</a>
				</div>

				<div class="gp_our-users_list_user">
					<a target="_blank" rel="noopener noreferrer" href="https://www.dnsfilter.com/">
						<img title="Used by DNSFilter"
							height="48"
							src="{{@shared.assetsHost}}/img/sponsors/dnsfilter.png"
							loading="lazy">
					</a>
				</div>

				<div class="gp_our-users_list_user">
					<a target="_blank" rel="noopener noreferrer" href="https://gcore.com/">
						<img title="Used by Gcore"
							width="162"
							height="48"
							src="{{@shared.assetsHost}}/img/sponsors/gcore.svg"
							loading="lazy">
					</a>
				</div>
			</div>
		</div>

		<div class="gp_join-network" id="join-the-network">
			<span class="gp_join-network_title">Join the network</span>
			<span class="gp_join-network_subtitle">
				To join the Globalping probe network all you have to do is run our container and get 150 credits per day.
			</span>

			<div class="gp_join-network_switch-wrapper">
				<span class="gp_join-network_switch">
					<span class="{{#if joinNetSwitchValue === 'docker'}}active{{/if}}"
						on-click="@this.set('joinNetSwitchValue', 'docker')">
						Docker
					</span>
					<span class="{{#if joinNetSwitchValue === 'podman'}}active{{/if}}"
						on-click="@this.set('joinNetSwitchValue', 'podman')">
						Podman
					</span>
				</span>
			</div>

			<div class="gp_join-network_cmd-block">
				<div class="gp_join-network_cmd-block_command {{#if showCommandsBlock}}opened{{/if}}">
					{{#if showCommandsBlock}}
						{{#each netCmdTextFull:idx}}
							<div class="gp_join-network_cmd-block_command_row">
								<span>{{idx + 1}}</span>
								<span>{{this.cmd}}</span>
								{{#if this.comment}}
									<span>{{this.comment}}</span>
								{{/if}}
							</div>
						{{/each}}
					{{else}}
						<div class="gp_join-network_cmd-block_command_oneliner">
							{{netCmdText}}
						</div>
					{{/if}}
				</div>

				<button class="gp_join-network_cmd-block_btn gp_btn_green"
					as-clipboard data-clipboard-text="{{showCommandsBlock ? netCmdTextFullClipboard : netCmdText}}">
					<img width="20"
						height="20"
						src="{{@shared.assetsHost}}/img/copy-icon.svg">
				</button>

				<div class="gp_join-network_cmd-block_open-btn {{#if showCommandsBlock}}active{{/if}}"
					on-click="@this.toggle('showCommandsBlock')">
					<img width="9"
						height="6"
						src="{{@shared.assetsHost}}/img/chevron.svg">
				</div>
			</div>

			<span class="gp_join-network_descr">
				Once you connect you will become part of the global community that powers the Globalping Platform.
				The container will work on both x86 and ARM architectures.
			</span>
		</div>

		<div class="gp_join-community">
			<div class="gp_join-community_content">
				<span class="gp_join-community_content_title">
					We invite everyone to join our community and help us develop our projects.
				</span>

				<ul class="gp_join-community_content_list">
					<li>We promise a friendly discussion in our issues and code reviews</li>
					<li>We appreciate your work and will review your PRs in a timely manner</li>
					<li>We are open to new ideas and technologies</li>
					<li>You don't have to be a developer to help</li>
					<li>Copywriters, community moderators, dev relations, media relations... are all equally important</li>
				</ul>

				<img class="gp_join-community_img"
					width="363"
					height="416"
					src="{{@shared.assetsHost}}/img/polygons_3.svg">
			</div>
		</div>

		<div class="gp_gh-links">
			<div class="gp_gh-links_header">
				<span class="gp_gh-links_header_title">Become an open source contributor!</span>

				<img width="64"
					height="64"
					src="{{@shared.assetsHost}}/img/github.svg">
			</div>

			<div class="gp_gh-links_content">
				<a target="_blank" rel="noopener noreferrer" href="https://github.com/jsdelivr/globalping" class="gp_gh-links_content_item">
					<span class="gp_gh-links_content_item_title">
						Globalping API
					</span>

					<span class="gp_gh-links_content_item_descr">
						Learn more about the project, the API, tools and become a contributor
					</span>
				</a>

				<a target="_blank" rel="noopener noreferrer" href="https://github.com/jsdelivr/globalping-cli" class="gp_gh-links_content_item">
					<span class="gp_gh-links_content_item_title">
						Globalping CLI
					</span>

					<span class="gp_gh-links_content_item_descr">
						Our simple to use CLI is also open source and awaits for your feedback.
					</span>
				</a>

				<a target="_blank" rel="noopener noreferrer" href="https://github.com/jsdelivr/globalping-probe" class="gp_gh-links_content_item">
					<span class="gp_gh-links_content_item_title">
						Globalping Probe
					</span>

					<span class="gp_gh-links_content_item_descr">
						Explore the codebase of our software probes and firmware for hardware probes as well
					</span>
				</a>
			</div>
		</div>

		<div class="gp_probe">
			<div class="gp_probe_promo">
				<img width="198"
					height="198"
					src="{{@shared.assetsHost}}/img/probe.png"
					srcset="{{@shared.assetsHost}}/img/probe@2x.png 2x">

				<div class="gp_probe_promo_content">
					<span class="gp_probe_promo_content_title">
						Get a hardware probe
					</span>

					<span class="gp_probe_promo_content_descr">
						Become a GitHub sponsor for $10/month or more and get your own hardware probe to install in your home or office network.
					</span>

					<a target="_blank" rel="noopener noreferrer" href="https://github.com/sponsors/jsdelivr" class="gp_probe_promo_content_btn gp_btn_green">
						<img width="20"
							height="20"
							src="{{@shared.assetsHost}}/img/github.small.svg">

						Become a GitHub Sponsor
					</a>
				</div>
			</div>

			<div class="gp_probe_get-probe">
				<div class="gp_probe_get-probe_header">
					How to get a probe?
				</div>

				<div class="gp_probe_get-probe_list">
					<div class="gp_probe_get-probe_list_item">
						<div class="gp_probe_get-probe_list_item_progress">
							<img width="24"
								height="24"
								src="{{@shared.assetsHost}}/img/circle-icon.svg">

							<span></span>
						</div>

						<div class="gp_probe_get-probe_list_item_content">
							<span>Become a sponsor</span>
							<span>Become a GitHub Sponsor for $10+/month.</span>
						</div>
					</div>

					<div class="gp_probe_get-probe_list_item">
						<div class="gp_probe_get-probe_list_item_progress">
							<img width="24"
								height="24"
								src="{{@shared.assetsHost}}/img/circle-icon.svg">

							<span></span>
						</div>

						<div class="gp_probe_get-probe_list_item_content">
							<span>
								<a target="_blank" rel="noopener noreferrer" href="https://forms.gle/9jSzytJpTDYJmS2W8">Fill the form</a>
							</span>
							<span>Fill out this form with your details.</span>
						</div>
					</div>

					<div class="gp_probe_get-probe_list_item">
						<div class="gp_probe_get-probe_list_item_progress">
							<img width="24"
								height="24"
								src="{{@shared.assetsHost}}/img/circle-icon.svg">
						</div>

						<div class="gp_probe_get-probe_list_item_content">
							<span>Probe arrives</span>
							<span>Wait for the probe to arrive.</span>
						</div>
					</div>
				</div>
			</div>

			<div class="gp_probe_how-it-works">
				<div class="gp_probe_how-it-works_header">How it works?</div>
				<div class="gp_probe_how-it-works_text">
					<span>
						Installing our hardware probe simplifies the whole process and <b>removes the need of having a computer running 24/7.</b>
						Just connect the probe to your switch or router via an ethernet cable and you are done!
					</span>
					<span>
						Our hardware probes are fully secure. <b>They don't allow any kind of access to your LAN</b>, they block all malicious and abusive endpoints,
						don't open any ports whatsoever and the firmware itself is fully open source.
					</span>
				</div>

				<div class="gp_probe_how-it-works_btns">
					<a target="_blank"
						rel="noopener noreferrer"
						href="https://github.com/jsdelivr/globalping-hwprobe"
						class="gp_probe_how-it-works_btns_learn-more gp_btn_black">
						Learn more
					</a>

					<a target="_blank"
						rel="noopener noreferrer"
						href="https://github.com/sponsors/jsdelivr"
						class="gp_probe_how-it-works_btns_sponsor gp_btn_green">
						<img width="20"
							height="20"
							src="{{@shared.assetsHost}}/img/github.small.svg">

						Become a GitHub Sponsor
					</a>
				</div>
			</div>
		</div>

		<div class="gp_sponsors">
			<div class="gp_sponsors_content">
				<div class="gp_sponsors_content_info">
					<span class="gp_sponsors_content_info_title">Globalping sponsors</span>

					<span class="gp_sponsors_content_info_descr">
						We thank everyone who decided to help our project by either running multiple globally distributed probes or donating to our cause.
					</span>
				</div>

				<div class="gp_sponsors_content_list" data-testid="gp-sponsors">
					<div class="gp_sponsors_content_list_tier-one">
						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://xtom.com">
								<img title="Sponsored by xTom"
									width="101"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/xtom.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://looking.house">
								<img title="Sponsored by Looking.house"
									width="151"
									height="34"
									src="{{@shared.assetsHost}}/img/sponsors/looking-house.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://www.starrydns.com">
								<img title="Sponsored by StarryDNS"
									width="160"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/starry.png">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://www.ip2location.io/">
								<img title="Sponsored by IP2Location"
									width="169"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/ip2location.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://www.exoscale.com">
								<img title="Sponsored by Exoscale"
									width="210"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/exoscale.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://www.fdcservers.net">
								<img title="Sponsored by FDCServers"
									width="95"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/fdc.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://ipinfo.io/">
								<img title="Sponsored by IPInfo"
									width="93"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/ipinfo.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://www.edisglobal.com/">
								<img title="Sponsored by EDIS Global"
									width="91"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/edis-global.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://www.misaka.io">
								<img title="Sponsored by Misaka Network, Inc."
									width="95"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/misaka.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://zappiehost.com">
								<img title="Sponsored by Zappie Host"
									width="97"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/zappiehost.png">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://gcore.com/">
								<img title="Sponsored by Gcore"
									width="141"
									height="42"
									src="{{@shared.assetsHost}}/img/sponsors/gcore.svg">
							</a>
							<!-- swap images for better look depending on screenWidth -->
							{{#if screenWidth < 768}}
								<a target="_blank" rel="noopener noreferrer" href="https://www.dnsfilter.com/">
									<img title="Sponsored by DNSFilter"
										width="120"
										height="28"
										src="{{@shared.assetsHost}}/img/sponsors/dnsfilter.png">
								</a>
							{{else}}
								<a target="_blank" rel="noopener noreferrer" href="https://ipgeolocation.io/">
									<img title="Sponsored by IP Geolocation"
										width="97"
										height="56"
										src="{{@shared.assetsHost}}/img/sponsors/ipgeolocation.svg">
								</a>
							{{/if}}
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://shockhosting.com/">
								<img title="Sponsored by Shock Hosting"
									width="220"
									height="30"
									src="{{@shared.assetsHost}}/img/sponsors/shockhosting.svg">
							</a>
							<!-- swap images for better look depending on screenWidth -->
							{{#if screenWidth < 768}}
								<a target="_blank" rel="noopener noreferrer" href="https://ipgeolocation.io/">
									<img title="Sponsored by IP Geolocation"
										width="97"
										height="56"
										src="{{@shared.assetsHost}}/img/sponsors/ipgeolocation.svg">
								</a>
							{{else}}
								<a target="_blank" rel="noopener noreferrer" href="https://www.dnsfilter.com/">
									<img title="Sponsored by DNSFilter"
										width="120"
										height="28"
										src="{{@shared.assetsHost}}/img/sponsors/dnsfilter.png">
								</a>
							{{/if}}
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://onidel.com/">
								<img title="Sponsored by Onidel"
									width="130"
									height="32"
									src="{{@shared.assetsHost}}/img/sponsors/onidel.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://www.kuroit.com/">
								<img title="Sponsored by Kuroit"
									width="128"
									height="34"
									src="{{@shared.assetsHost}}/img/sponsors/kuroit.png">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://exservers.net//">
								<img title="Sponsored by ExServers"
									width="156"
									height="28"
									src="{{@shared.assetsHost}}/img/sponsors/exservers.png">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://netshop-isp.com.cy/">
								<img title="Sponsored by NetShop ISP"
									width="145"
									height="40"
									src="{{@shared.assetsHost}}/img/sponsors/netshop-logo-dark.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://oneprovider.com/">
								<img title="Sponsored by OneProvider"
									width="171"
									height="45"
									src="{{@shared.assetsHost}}/img/sponsors/oneprovider.svg">
							</a>

							<a target="_blank" rel="noopener noreferrer" href="https://www.mvps.net/">
								<img title="Sponsored by MVPS"
									width="158"
									height="50"
									src="{{@shared.assetsHost}}/img/sponsors/mvps.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://www.fastly.com/">
								<img title="Sponsored by Fastly"
									width="130"
									height="42"
									src="{{@shared.assetsHost}}/img/sponsors/fastly.svg">
							</a>

							<a target="_blank" rel="noopener noreferrer" href="https://www.host-stage.net/">
								<img title="Sponsored by HostStage"
									width="189"
									height="40"
									src="{{@shared.assetsHost}}/img/sponsors/host-stage.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://www.iplocate.io/">
								<img title="Sponsored by IPLocate"
									width="164"
									height="27"
									src="{{@shared.assetsHost}}/img/sponsors/iplocate.svg">
							</a>

							<a target="_blank" rel="noopener noreferrer" href="https://breezehost.io/">
								<img title="Sponsored by BreezeHost"
									width="121"
									height="46"
									src="{{@shared.assetsHost}}/img/sponsors/breezehost.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://cloudlooking.glass/">
								<img title="Sponsored by Cloud Looking Glass"
									width="147"
									height="40"
									src="{{@shared.assetsHost}}/img/sponsors/cloud-looking-glass.png">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://www.datapacket.com/">
								<img title="Sponsored by Datapacket"
									width="180"
									height="26"
									src="{{@shared.assetsHost}}/img/sponsors/datapacket.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://www.digiturunc.com/">
								<img title="Sponsored by Digiturunc"
									width="122"
									height="56"
									src="{{@shared.assetsHost}}/img/sponsors/digiturunc.png">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://perlod.com/">
								<img title="Sponsored by Perlod"
									width="112"
									height="32"
									src="{{@shared.assetsHost}}/img/sponsors/perlod.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://netalis.fr/">
								<img title="Sponsored by Netalis"
									width="157"
									height="32"
									src="{{@shared.assetsHost}}/img/sponsors/netalis.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://pipehost.net/">
								<img title="Sponsored by PipeHost"
									width="158"
									height="29"
									src="{{@shared.assetsHost}}/img/sponsors/pipehost.svg">
							</a>
						</div>

						<div class="gp_sponsors_content_list_tier-one_row">
							<a target="_blank" rel="noopener noreferrer" href="https://synthient.com/">
								<img title="Sponsored by Synthient"
									width="156"
									height="40"
									src="{{@shared.assetsHost}}/img/sponsors/synthient.svg">
							</a>
							<a target="_blank" rel="noopener noreferrer" href="https://ishosting.com/en/vps">
								<img title="Sponsored by is*hosting"
									width="158"
									height="30"
									src="{{@shared.assetsHost}}/img/sponsors/ishosting.svg">
							</a>
						</div>

						<!-- <div class="gp_sponsors_content_list_tier-two">
							<div class="gp_sponsors_content_list_tier-two_row">
								<div class="gp_person-sponsor">Robert  Kowalski</div>

								<img width="57"
									height="19"
									src="{{@shared.assetsHost}}/img/sponsors/dell.svg">

								<div class="gp_person-sponsor">Magdalene Tabhita</div>
							</div>
						</div> -->
					</div>
				</div>

				<a href="mailto:d@globalping.io" class="gp_sponsors_content_btn gp_btn_green">
					Get in Contact
				</a>

				<img class="gp_sponsors_content_img"
					width="289"
					height="288"
					src="{{@shared.assetsHost}}/img/polygons_4.svg">
			</div>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const _ = require('../../assets/js/_.js');
	const ipRegex = require('../../assets/js/utils/ip-regex');
	const listeners = require('../../assets/js/utils/listeners');
	const clipboard = require('../../assets/js/decorators/clipboard');
	const http = require('../../assets/js/utils/http');
	const dataCache = require('../../assets/js/utils/data-cache');
	const getMeasurementTitle = require('../../assets/js/utils/measurement-title');

	const CLIENT_DEFAULT_PING_OPTS = {
		protocol: 'ICMP',
	};
	const API_DEFAULT_PING_OPTS = {
		protocol: 'ICMP',
	};
	const CLIENT_DEFAULT_TRACEROUTE_OPTS = {
		protocol: 'ICMP',
	};
	const API_DEFAULT_TRACEROUTE_OPTS = {
		protocol: 'ICMP',
	};
	const CLIENT_DEFAULT_DNS_OPTS = {
		protocol: 'UDP',
		query: {
			type: 'A',
		},
		trace: false,
	};
	const API_DEFAULT_DNS_OPTS = {
		protocol: 'UDP',
		query: {
			type: 'A',
		},
		trace: false,
	};
	const CLIENT_DEFAULT_MTR_OPTS = {
		protocol: 'ICMP',
	};
	const API_DEFAULT_MTR_OPTS = {
		protocol: 'ICMP',
	};
	const CLIENT_DEFAULT_HTTP_OPTS = {
		protocol: 'HTTPS',
		request: {
			method: 'GET',
		},
	};
	const API_DEFAULT_HTTP_OPTS = {
		protocol: 'HTTPS',
		request: {
			method: 'HEAD',
		},
	};
	const DEFAULT_PACKETS_AMOUNT = 3;
	const DEFAULT_LIMIT = 1;
	const DOCKER_CMD_CONTENT = 'docker run -d --log-driver local --network host --restart=always --name globalping-probe globalping/globalping-probe';
	const DOCKER_CMD_CONTENT_FULL = [
		{
			cmd: 'docker run -d \\',
			comment: ' # Make sure the container runs on boot',
		},
		{
			cmd: '--log-driver local \\',
			comment: ' # Use the modern logging driver to ensure old logs are deleted',
		},
		{
			cmd: '--network host \\',
			comment: ' # Bypass overlay and mesh networking to ensure they dont impact latency tests',
		},
		{
			cmd: '--restart=always \\',
			comment: ' # Restart the container if it crashes',
		},
		{
			cmd: '--name globalping-probe globalping/globalping-probe',
			comment: '',
		},
	];
	const PODMAN_CMD_CONTENT = 'sudo podman run -d --cap-add=NET_RAW --network host --restart=always --name globalping-probe globalping/globalping-probe';
	const PODMAN_CMD_CONTENT_FULL = [
		{
			cmd: 'sudo \\',
			comment: ' # Allows the --cap-add=NET_RAW option to work properly',
		},
		{
			cmd: 'podman run -d \\',
			comment: ' # The container will NOT start on boot. You need to create a systemd service first.',
		},
		{
			cmd: '--cap-add=NET_RAW \\',
			comment: ' # Network permissions to run ping',
		},
		{
			cmd: '--network host \\',
			comment: '# Bypass overlay and mesh networking to ensure they dont impact latency tests',
		},
		{
			cmd: '--restart=always \\',
			comment: ' # Restart the container if it crashes',
		},
		{
			cmd: '--name globalping-probe globalping/globalping-probe',
			comment: '',
		},
	];
	const INITIAL_MAIN_OPTS_VALUES = {
		type: 'ping',
		target: '',
		location: 'World',
		limit: '10',
	};
	const MAP_MIN_ZOOM = 2;
	const MAP_MAX_ZOOM = 22;
	const MAP_ZOOM_REG = 3.74;
	const MAP_CENTER_REG = { lat: 48, lng: 16 };
	const MAP_ZOOM_ALT = 2.14;
	const MAP_CENTER_ALT = { lat: 30, lng: 18 };
	const DEFAULT_MARKER_COLOR = '#C0C0C0';
	const PROBE_NO_TIMING_VALUE = _.getProbeTimeOutValue();
	const PROBE_STATUS_FAILED = _.getProbeStatusFailedValue();
	const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();
	const PROBE_OFFLINE_TEXT = 'Probe offline';
	const RAW_OUTPUT_LINES_BATCH_LIMIT = 40;
	const DEFAULT_TARGET_VALUE = 'cdn.jsdelivr.net';
	const INFINITE_MEASUREMENT_PACKETS = 16;
	const INFINITE_MEASUREMENT_LIMIT = 5;
	const RATE_LIMIT_HEADERS = [
		'x-ratelimit-limit',
		'x-ratelimit-consumed',
		'x-ratelimit-remaining',
		'x-ratelimit-reset',
		'x-credits-consumed',
		'x-credits-remaining',
		'x-request-cost',
	];
	const PORT_SUPPORTED_BY_TYPE = {
		ping: [ 'TCP' ],
		traceroute: [ 'TCP' ],
		mtr: [ 'TCP', 'UDP' ],
	};
	const DEFAULT_SORT_BY = 'location';
	const DEFAULT_SORT_ORDER = 'asc';
	const SORT_ORDER_OPTS = [ 'asc', 'desc' ];
	const MEASUREMENT_TYPES = [ 'ping', 'traceroute', 'mtr', 'dns', 'http' ];
	const TABLE_COLUMNS_CACHE = new Map();
	const SORT_BY_OPTS = [
		{
			value: 'location',
			name: 'Location',
		},
		{
			value: 'quality',
			name: 'Quality',
		},
		{
			value: 'rtt-last',
			name: 'Rtt last',
		},
		{
			value: 'min',
			name: 'Rtt min',
		},
		{
			value: 'avg',
			name: 'Rtt avg',
		},
		{
			value: 'max',
			name: 'Rtt max',
		},
	];
	const ALLOWED_COLLAPSE_OPTS = [ 'all', 'none' ]; // default would be "response bodies"

	const getMarkerSize = (probeCount, zoom) => {
		let size = {
			svgWidth: 16,
			svgHeight: 16,
			circleRadius: 4.5,
			strokeWidth: 1.5,
		};

		if (probeCount > 1) {
			let scalingFactor = probeCount.toString().length;
			size.svgWidth += 4 * scalingFactor + 4;
			size.svgHeight += 4 * scalingFactor + 4;
			size.circleRadius += 2 * scalingFactor + 1.5;
			size.strokeWidth += .5;
		}

		if (zoom >= 5) {
			size.svgWidth *= 1.1;
			size.svgHeight *= 1.1;
		}

		if (zoom >= 10) {
			size.svgWidth *= 1.1;
			size.svgHeight *= 1.1;
		}

		return size;
	};
	const originalMapMarkersPos = new Map();
	const DEFAULT_MARKER_DIMENSIONS = 24;

	let map;
	let infoWindows = [];
	let mapMarkers = [];
	let probesMarkers = [];
	let probesInfoWindows = [];
	let mapProbesClusters = [];

	component.exports = {
		decorators: {
			clipboard,
		},
		data () {
			return {
				_,
				map: null,
				display: null,
				view: null,
				rawProbes: '',
				PROBE_NO_TIMING_VALUE,
				PROBE_STATUS_FAILED,
				PROBE_STATUS_OFFLINE,
				DEFAULT_TARGET_VALUE,
				INFINITE_MEASUREMENT_LIMIT,
				INITIAL_MAIN_OPTS_VALUES,
				testTypesList: [ 'ping', 'traceroute', 'DNS', 'MTR', 'HTTP' ],
				mainOptions: {
					...INITIAL_MAIN_OPTS_VALUES,
				},
				showMap: true,
				originalShowMap: true,
				transitionMap: true,
				infiniteSwitchEnabled: false,
				showMeasurementOpts: false,
				dnsTypesList: [ 'A', 'AAAA', 'ANY', 'CNAME', 'DNSKEY', 'DS', 'MX', 'NS', 'NSEC', 'PTR', 'RRSIG', 'SOA', 'TXT', 'SRV', 'SVCB' ],
				netDockerCmdText: DOCKER_CMD_CONTENT,
				netDockerCmdTextFull: DOCKER_CMD_CONTENT_FULL,
				netPodmanCmdText: PODMAN_CMD_CONTENT,
				netPodmanCmdTextFull: PODMAN_CMD_CONTENT_FULL,
				totalProbes: 0,
				totalCities: 0,
				totalCountries: 0,
				pingOpts: JSON.parse(JSON.stringify(CLIENT_DEFAULT_PING_OPTS)), // deep copy is needed here, as default values for other options are deep-copied elsewhere
				tracerouteOpts: CLIENT_DEFAULT_TRACEROUTE_OPTS,
				dnsOpts: CLIENT_DEFAULT_DNS_OPTS,
				mtrOpts: CLIENT_DEFAULT_MTR_OPTS,
				httpOpts: CLIENT_DEFAULT_HTTP_OPTS,
				inputErrors: {},
				testResults: null,
				testInProgress: false,
				runTestBtnDisabled: true,
				gmapsReady: false,
				runTestBtnDelayTimeout: null,
				testReqCancelFn: null,
				activeTestRunId: 0,
				gmapsIdleListener: null,
				notAppliedOpts: {},
				defaultPacketsAmount: DEFAULT_PACKETS_AMOUNT,
				defaultLimit: DEFAULT_LIMIT,
				probesMinTiming: 5,
				joinNetSwitchValue: 'docker',
				showCommandsBlock: false,
				scrolledToResId: null,
				modifiedMeasOptsCnt: 0,
				appliedMeasOpts: {},
				shareResHeaderData: null,
				mobileShareResHeaderData: null,
				runTestBtnText: 'Run Test',
				testReqParams: null,
				probesResponse: null,
				clusterRadius: null,
				nextClusterRadius: null,
				shareResFlow: false,
				activeTargetIdx: 0,
				rawOutputMode: true,
				measurementsMetadata: null,
				targetsArr: [],
				hiddenTestResults: { 0: [], 1: [] },
				hiddenResponseBodies: { 0: [], 1: [] },
				qsMeasurementIdsArr: [],
				showCreditsErrorBar: false,
				infiniteMeasIds: [],
				isTestStopped: false,
				isInfiniteModeRes: false,
				prevProbesMeasId: null,
				preparedTestResults: [],
				ddHandlerSet: false,
				showCreditsData: false,
				rateCreditsData: null,
				measurementErrMsg: null,
				probesMaxTiming: 200,
				sortBy: DEFAULT_SORT_BY,
				sortOrder: DEFAULT_SORT_ORDER,
				sortByOpts: SORT_BY_OPTS,
				tableColumns: [],
				locationAutofilled: false,
				showingNetworkLogos: false,
				collapseFromQuery: null,
				skipDefaultAutoCollapseFromQuery: false,
				integrationExamples: [
					{
						name: 'n8n',
						description: 'Add Globalping to your n8n workflows and get access to thousands of probes.',
						img: '/img/integrations/n8n.svg',
					},
					{
						name: 'Uptime Kuma',
						description: 'Self-hosted uptime monitoring with native Globalping integration.',
						img: '/img/integrations/uptime-kuma.svg',
					},
					{
						name: 'Zapier',
						description: 'Build advanced automations without writing any code using Zapier.',
						img: '/img/integrations/zapier.svg',
					},
					{
						name: 'Upptime',
						description: 'GitHub Actions based uptime monitoring with Globalping.',
						img: '/img/integrations/upptime.svg',
					},
				],
			};
		},
		computed: {
			title () {
				return this.get('_measurementOgTitle');
			},
			description () {
				return this.get('_measurementOgDescription');
			},
			disablePort () {
				let type = this.get('mainOptions.type').toLowerCase();
				let opts = this.get(`${type}Opts`);

				let supportedProtocols = PORT_SUPPORTED_BY_TYPE[type];

				if (!supportedProtocols) {
					return false;
				}

				return !supportedProtocols.includes(opts?.protocol ?? '');
			},
			location: {
				get () {
					// This is a one-way setter.
					return this.get('_location');
				},
				set (value) {
					this.set('_location', value);
					this.set('mainOptions.location', value.replace(/%/g, '+'));
				},
			},
			allCollapsed () {
				let targetCount = this.get('targetsArr').length;
				let testProbeCount = this.get('preparedTestResults').length;

				for (let i = 0; i < targetCount; i++) {
					if (this.get(`hiddenTestResults[${i}]`).length !== testProbeCount) {
						return false;
					}
				}

				return true;
			},
			tableOutputReady () {
				let preparedTestResults = this.get('preparedTestResults') || [];
				let expectedTargetsCnt = this.get('isInfiniteModeRes') || this.get('qsMeasurementIdsArr.length') <= 1
					? this.get('targetsArr.length')
					: this.get('qsMeasurementIdsArr.length');
				let actualTargetsCnt = preparedTestResults[0]?.statsPerTarget?.length || 0;

				return preparedTestResults.length && (!expectedTargetsCnt || actualTargetsCnt >= expectedTargetsCnt);
			},
			anyResponseBodyCollapsible () {
				if (Ractive.isServer) {
					return false;
				}

				let preparedTestResults = this.get('preparedTestResults') || [];
				let targetsArr = this.get('targetsArr') || [];
				let charsPerLine = this.getRawOutputCharsPerLine();

				for (let targetIdx = 0; targetIdx < targetsArr.length; targetIdx++) {
					for (let i = 0; i < preparedTestResults.length; i++) {
						let body = preparedTestResults[i]?.statsPerTarget?.[targetIdx]?.responseBody || '';

						if (_.shouldCollapseResponseBody(body, charsPerLine)) {
							return true;
						}
					}
				}

				return false;
			},
		},
		onrender () {
			if (!Ractive.isServer) {
				this.set('@shared.googleMapsLoaded', true);

				if (app.loaded) {
					setTimeout(this.initMap.bind(this));
				}

				listeners.screenWidthListener(this);
			}
		},
		oninit () {
			if (!Ractive.isServer) {
				this.on('c-gp-header.main-logo-click', () => {
					app.router.history.pushState({}, document.title, '/');
					app.router.dispatch('/', { reload: true, noHistory: true });
					return false;
				});

				// check if ids are present in query string
				// if so - it is a share-results-flow
				let measurement = this.get('measurement');
				let qsMeasurementIdsArr = [];
				let isInfiniteMeas = false;
				let isMultiEpMeas = false;

				// A separator for IDs for regular link is a comma, for infinite one - plus sign
				if (measurement && measurement.includes(',')) {
					qsMeasurementIdsArr = measurement.split(',');
					isMultiEpMeas = true;
				} else if (measurement && measurement.includes('.')) {
					qsMeasurementIdsArr = measurement.split('.');
					isInfiniteMeas = true;

					this.set('infiniteSwitchEnabled', true);
					this.set('isInfiniteModeRes', true);
					this.set('rawOutputMode', false);
				} else if (measurement) {
					qsMeasurementIdsArr = [ measurement ];
				}

				if (qsMeasurementIdsArr.length) {
					this.set('qsMeasurementIdsArr', qsMeasurementIdsArr);
					this.set('shareResFlow', true);
					this.set('prevProbesMeasId', qsMeasurementIdsArr[0]);

					this.getMultipleTestMeasurementById(qsMeasurementIdsArr, isInfiniteMeas);
				}

				// read the map and display URL params and apply them
				let map = this.get('map');
				let display = this.get('display');

				if (map === 'hidden') {
					this.set('showMap', false);
					this.set('originalShowMap', false);
				}

				let nonDefaultDisplayValue = isMultiEpMeas || isInfiniteMeas ? 'raw' : 'table';

				if (display === nonDefaultDisplayValue) {
					// if valid, set the non-default value in params
					this.set('rawOutputMode', display === 'raw');
				} else {
					// otherwise set the appropriate default value
					// for multi-endpoint tests, this always sets the display to table
					this.set('rawOutputMode', nonDefaultDisplayValue !== 'raw');
				}

				// read the sorting URL params and apply them
				let by = this.get('by');
				let order = this.get('order');
				let sortByVals = this.getAllTableSortValues();

				if (sortByVals.includes(by)) {
					this.set('sortBy', by);
				}

				if (SORT_ORDER_OPTS.includes(order)) {
					this.set('sortOrder', order);
				}

				// read the collapse URL param and apply it once results are available
				let collapse = this.get('collapse');

				if (ALLOWED_COLLAPSE_OPTS.includes(collapse)) {
					this.set('collapseFromQuery', collapse);
				}

				// get probes from sessionStorage or fetch them and handle
				this.getProbesData();
				let location = this.get('location');

				if (location && !measurement) {
					this.set('locationAutofilled', true);
				}

				this.initResponseBodyCharWidth();

				this.observe('sortBy', (sortBy) => {
					app.router.replaceQueryParam('by', sortBy === DEFAULT_SORT_BY ? null : sortBy, this);
				});

				this.observe('sortOrder', (sortOrder) => {
					app.router.replaceQueryParam('order', sortOrder === DEFAULT_SORT_ORDER ? null : sortOrder, this);
				});

				this.observe('sortOrder sortBy preparedTestResults activeTargetIdx rawOutputMode', () => {
					let sortOrder = this.get('sortOrder');
					let sortBy = this.get('sortBy');
					let preparedTestResults = this.get('preparedTestResults');
					let rawOutputMode = this.get('rawOutputMode');
					let activeTargetIdx = rawOutputMode ? this.get('activeTargetIdx') : 0;

					if (preparedTestResults.length) {
						let sortedResults = _.sortGpMeasurementResults(preparedTestResults, sortBy, sortOrder, activeTargetIdx);
						let orderChanged = sortedResults.length !== preparedTestResults.length
							|| sortedResults.some((result, idx) => result.clientSideId !== preparedTestResults[idx]?.clientSideId);

						if (orderChanged) {
							this.set('preparedTestResults', sortedResults);
						}
					}
				});

				this.observe('testReqParams.type testReqParams.measurementOptions.trace', () => {
					let testType = this.get('testReqParams.type');

					if (!testType) {
						return;
					}

					let tableColumns = this.getTableColumns(testType);
					let sortByOpts = this.getSortOptionsFromTableColumns(tableColumns);
					let sortBy = this.get('sortBy');

					if (!_.isEqual(sortByOpts, this.get('sortByOpts')) || !_.isEqual(tableColumns, this.get('tableColumns'))) {
						this.set({ tableColumns, sortByOpts });
					}

					if (!sortByOpts.some(opt => opt.value === sortBy)) {
						this.set('sortBy', DEFAULT_SORT_BY);
						this.set('sortOrder', DEFAULT_SORT_ORDER);
						app.router.replaceQueryParam('by', null, this);
						app.router.replaceQueryParam('order', null, this);
					}
				});

				// persist non-default display value in the URL
				this.observe('rawOutputMode testReqParams.type', () => {
					let testType = this.get('testReqParams.type');

					if (!testType) {
						return;
					}

					let rawOutputMode = this.get('rawOutputMode');
					let isInfiniteMeas = this.get('isInfiniteModeRes');
					let isMultiEpMeas = this.get('measurement')?.split(',')?.length >= 2;

					if (isInfiniteMeas || isMultiEpMeas) {
						app.router.replaceQueryParam('display', rawOutputMode ? 'raw' : null, this);
					} else {
						app.router.replaceQueryParam('display', rawOutputMode ? null : 'table', this);
					}
				});

				// persist non-default map value in the URL
				this.observe('showMap', (showMap) => {
					if (!showMap && this.get('originalShowMap')) {
						return;
					}

					app.router.replaceQueryParam('map', showMap ? null : 'hidden', this);
				});

				this.observe('preparedTestResults', (preparedTestResults, prevPreparedTestResults) => {
					if (_.isEqual(preparedTestResults, prevPreparedTestResults)) {
						return;
					}

					let collapse = this.get('collapseFromQuery');
					let testType = (this.get('testReqParams.type') || '').toLowerCase();
					let targetCount = this.get('targetsArr')?.length || 0;
					let firstResultTargetCount = preparedTestResults?.[0]?.statsPerTarget?.length || 0;

					if (!preparedTestResults.length) {
						this.set('skipDefaultAutoCollapseFromQuery', false);
						return;
					}

					// respect query-driven collapse first and prevent subsequent partial-result updates from overriding it with default auto-collapse
					if (collapse) {
						if (collapse === 'none') {
							this.expandAllRawOutput({ withResponseBody: true });
						} else { // === 'all'
							this.collapseAllRawOutput();
						}

						this.set('collapseFromQuery', null);
						this.set('skipDefaultAutoCollapseFromQuery', true);
						return;
					}

					if (this.get('skipDefaultAutoCollapseFromQuery')) {
						return;
					}

					// skip default collapsing until all target data is present
					if (targetCount && targetCount !== firstResultTargetCount) {
						return;
					}

					if (prevPreparedTestResults.length === 0 && preparedTestResults.length > 0 && !collapse) {
						this.collapseAllRawOutput({ responseBodyOnly: true });
					}

					// close response bodies by default
					if (!collapse && testType === 'http' && preparedTestResults.length) {
						this.collapseAllRawOutput({ responseBodyOnly: true });
					}
				}, { deep: true, defer: true });

				this.observe('hiddenTestResults hiddenResponseBodies preparedTestResults targetsArr collapseFromQuery', () => {
					if (this.get('collapseFromQuery')) {
						return;
					}

					let preparedTestResults = this.get('preparedTestResults');
					let targetCount = this.get('targetsArr')?.length || 0;
					let firstResultTargetCount = preparedTestResults?.[0]?.statsPerTarget?.length || 0;

					if (!preparedTestResults.length) {
						app.router.replaceQueryParam('collapse', null, this);
						return;
					}

					// Avoid transient URL updates while multi-target results are still partially populated.
					if (targetCount && targetCount !== firstResultTargetCount) {
						return;
					}

					let hiddenTestResults = this.get('hiddenTestResults') || {};
					let hiddenResponseBodies = this.get('hiddenResponseBodies') || {};
					let testType = this.get('testReqParams.type');
					let isHttpTest = testType.toLowerCase() === 'http';
					let anyResponseBodyCollapsible = this.get('anyResponseBodyCollapsible');
					let availableTargets = targetCount;

					if (!availableTargets) {
						return;
					}

					let allCollapsed = true;
					let allExpanded = true;
					let allResponseBodiesExpanded = isHttpTest;

					for (let targetIdx = 0; targetIdx < availableTargets; targetIdx++) {
						let hidden = hiddenTestResults[targetIdx] || [];
						let hiddenContent = hiddenResponseBodies[targetIdx] || [];

						if (hidden.length !== preparedTestResults.length) {
							allCollapsed = false;
						}

						if (hiddenContent.length) {
							allResponseBodiesExpanded = false;
						}

						if (hidden.length) {
							allExpanded = false;
						}
					}

					let collapsedValue = null;

					if (allCollapsed) {
						collapsedValue = 'all';
					} else if (allExpanded && allResponseBodiesExpanded && (!isHttpTest || anyResponseBodyCollapsible)) {
						collapsedValue = 'none';
					}

					app.router.replaceQueryParam('collapse', collapsedValue, this);
				}, { defer: true, init: false });

				// handle test type switch
				this.observe('mainOptions.type', (type) => {
					// if qsMeasurementIdsArr - share-results-flow, so type would be set, we should ignore this case
					if (this.get('qsMeasurementIdsArr').length) {
						return;
					}

					this.resetMeasurementOptions(type);
				}, { init: false });

				// when infinite switch is enabled set limit to INFINITE_MEASUREMENT_LIMIT if limit is bigger than INFINITE_MEASUREMENT_LIMIT
				this.observe('infiniteSwitchEnabled', (infiniteSwitchEnabled) => {
					let currentLimit = this.get('mainOptions.limit');

					if (infiniteSwitchEnabled && currentLimit > INFINITE_MEASUREMENT_LIMIT) {
						this.set('mainOptions.limit', INFINITE_MEASUREMENT_LIMIT);
					} else if (infiniteSwitchEnabled === false && currentLimit > INFINITE_MEASUREMENT_LIMIT) {
						this.set('mainOptions.limit', INITIAL_MAIN_OPTS_VALUES.limit);
					}
				});

				// handle limit changing when infinite switch is enabled - disable input if it is bigger than INFINITE_MEASUREMENT_LIMIT
				this.observe('mainOptions.limit', (currentLimit) => {
					let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

					if (infiniteSwitchEnabled && currentLimit >= INFINITE_MEASUREMENT_LIMIT) {
						this.set('mainOptions.limit', INFINITE_MEASUREMENT_LIMIT);
					}
				});

				// handle join-network switch and commands content
				this.observe('joinNetSwitchValue', (joinNetSwitchValue) => {
					let netCmdText;
					let netCmdTextFull;

					switch (joinNetSwitchValue) {
						case 'podman':
							netCmdText = this.get('netPodmanCmdText');
							netCmdTextFull = this.get('netPodmanCmdTextFull');
							break;
						case 'docker':
						default:
							netCmdText = this.get('netDockerCmdText');
							netCmdTextFull = this.get('netDockerCmdTextFull');
					}

					this.set('netCmdText', netCmdText);
					this.set('netCmdTextFull', netCmdTextFull);

					let clipboardValue = netCmdTextFull.map(part => part.cmd).join('\n');

					this.set('netCmdTextFullClipboard', clipboardValue);

					if (this.get('showCommandsBlock')) {
						this.set('showCommandsBlock', false);
					}
				});

				// handle show-hide full join-network command
				this.observe('showCommandsBlock', (showCommandsBlock) => {
					if (showCommandsBlock) {
						this.expandCmdBlock();
					} else {
						this.collapseCmdBlock();
					}
				}, { init: false, defer: true });

				// zoom to results once we get the first response
				this.observe('realTimeTestResResponse', (responses, prevResponses) => {
					if (!prevResponses && responses && responses.every(r => r.results.length) && responses[0]) {
						this.zoomToResults(responses[0].locations);
					}
				}, { init: false });

				// handle test results in real time
				this.observe('realTimeTestResResponse', (realTimeTestResResponse) => {
					if (!realTimeTestResResponse) { return; }

					// clear refetch timeout for the related request when it's finished, collect response statuses
					let respStatuses = realTimeTestResResponse.reduce((statusObj, r, rIdx) => {
						if (r.status === 'finished') {
							this.get(`testReqCancelFn[${rIdx}]`)?.();
							return { ...statusObj, [rIdx]: true };
						}

						return { ...statusObj, [rIdx]: false };
					}, {});

					// check respStatuses and handle the case when all requests are finished unless it is an infinite flow
					let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
					let targetsArrLength = this.get('targetsArr').length;

					if (
						!(targetsArrLength === 1 && infiniteSwitchEnabled)
						&& Object.values(respStatuses).length === targetsArrLength
						&& Object.values(respStatuses).every(s => s === true)
					) {
						this.set('testInProgress', false);

						// if it is a share-results-flow - scroll mapBlock into the view
						if (this.get('shareResFlow')) {
							this.scrollMapIntoView();
						} else {
							this.disableRunTestBtnForDelay();
						}
					}

					if (realTimeTestResResponse && realTimeTestResResponse.length) {
						realTimeTestResResponse.forEach((rtTestRes, rtTestResIdx) => {
							let prevTestResults = this.get(`testResults[${rtTestResIdx}]`);
							let testResults = rtTestRes.results.map((res, resIdx) => ({
								id: rtTestRes.id,
								clientSideId: resIdx,
								target: rtTestRes.target,
								type: rtTestRes.type,
								clientSideStartedAt: prevTestResults ? prevTestResults[resIdx].clientSideStartedAt : rtTestRes.clientSideStartedAt,
								clientSideUpdatedAt: rtTestRes.clientSideUpdatedAt,
								serverTime: new Date(rtTestRes.updatedAt).getTime() - new Date(rtTestRes.createdAt).getTime(),
								status: rtTestRes.status,
								...res,
							}));

							if (JSON.stringify(testResults) !== JSON.stringify(prevTestResults)) {
								this.set(`testResults[${rtTestResIdx}]`, testResults);
							}
						});
					}
				}, { init: false });

				// prepare data for Markers of the map, timings for the map scale
				this.observe('testResults', (testResults) => {
					if (!testResults) { return; }

					let testType = this.get('mainOptions.type');
					let dnsTraceEnabled = this.isDnsTraceEnabled();
					let targetsCnt = this.get('targetsArr').length;
					let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

					// combine results
					// if it is a regular measurement then each array element is corresponds to each target, these arrays elements contain data per probe for this target
					// if Infinite measurement - each array element is a new request's response, each el inside such array is a data for probe
					let parsedMeasData = testResults.reduce((mData, tRes, tResIdx) => {
						if (!tRes || !tRes.length) {
							return mData;
						}

						let mappedRes = tRes.map((res, resIdx) => {
							let calcTiming = null;
							let data = {
								id: res.id,
								clientSideId: res.clientSideId,
								network: res.probe.network,
								city: res.probe.city,
								country: res.probe.country,
								lat: res.probe.latitude,
								lng: res.probe.longitude,
								targets: [ res.target ],
								failureSources: [ res.result.failureSource ],
								isInProgress: [ res.result.status === 'in-progress' ],
							};

							if (infiniteSwitchEnabled) {
								let { packetsRtt } = _.parseGpRawOutputForTimings(res.result.rawOutput);
								let prevData = tResIdx - 1 >= 0 ? mData[tResIdx - 1][resIdx] : null;
								let prevPacketsRtt = prevData ? prevData.packetsRtt : [];
								let allCurrPacketsRtt = [ ...prevPacketsRtt, ...packetsRtt ];
								let numericPacketsRtt = allCurrPacketsRtt.filter(v => typeof v === 'number');

								data = {
									...data,
									packetsRtt: allCurrPacketsRtt,
								};

								if (res.result.status === PROBE_STATUS_FAILED) {
									calcTiming = {
										value: PROBE_STATUS_FAILED,
									};
								} else if (res.result.status === PROBE_STATUS_OFFLINE) {
									calcTiming = {
										value: PROBE_STATUS_OFFLINE,
									};
								} else if (numericPacketsRtt.length) {
									calcTiming = {
										value: Math.round(numericPacketsRtt.reduce((sum, rtt) => sum += rtt, 0) / numericPacketsRtt.length),
										units: ' ms',
									};
								} else if (packetsRtt.length && packetsRtt.every(v => v === _.getProbeTimeOutValue())) {
									calcTiming = {
										value: _.getProbeTimeOutValue(),
									};
								} else {
									calcTiming = {
										value: prevData ? prevData.timings[0] : null,
									};

									data.failureSources = [ prevData?.failureSources?.[0] ];
								}
							} else if (res.result.status !== 'in-progress') {
								calcTiming = _.calcGpTestResTiming(testType, res, dnsTraceEnabled);
							}

							if (calcTiming?.extraValues?.errorStatus) {
								calcTiming.value = calcTiming.extraValues.errorStatus;
							}

							let resTiming = !calcTiming ? null : typeof calcTiming.value === 'number' ? `${Math.round(calcTiming.value)}${calcTiming.units}` : calcTiming.value;

							let extraValues = calcTiming?.extraValues;
							let httpStatus = extraValues?.httpStatus?.value;
							let dnsStatus = extraValues?.dnsStatus?.value;
							let errorCode = null;

							if (extraValues?.errorStatus === _.getProbeStatusHttpErrorValue()) {
								errorCode = `HTTP ${httpStatus}`;
							} else if (extraValues?.errorStatus === _.getProbeStatusDnsErrorValue() && dnsStatus !== null && typeof dnsStatus !== 'undefined') {
								errorCode = dnsStatus;
							}

							return {
								...data,
								timings: [ resTiming ],
								errorCodes: [ errorCode ],
							};
						});

						return { ...mData, [tResIdx]: mappedRes };
					}, {});

					// markersData for the first target, regular flow
					let markersData = parsedMeasData[0];

					// in case of infinite flow, get the latest data
					if (infiniteSwitchEnabled) {
						let lastIdx = Object.keys(parsedMeasData).length - 1;

						markersData = parsedMeasData[lastIdx];
					}

					// if there are another targets then we should add its data to markersData respectively
					if (targetsCnt > 1) {
						for (let cnt = 1; cnt < targetsCnt; cnt++) {
							if (!parsedMeasData[cnt]) { return; }

							markersData = markersData.map((mD) => {
								let secReqMD = parsedMeasData[cnt].find(i => i.clientSideId === mD.clientSideId);

								return {
									...mD,
									timings: [ ...mD.timings, ...secReqMD.timings ],
									errorCodes: [ ...mD.errorCodes, ...secReqMD.errorCodes ],
									targets: [ ...mD.targets, ...secReqMD.targets ],
									failureSources: [ ...mD.failureSources, ...secReqMD.failureSources ],
									isInProgress: [ ...mD.isInProgress, ...secReqMD.isInProgress ],
								};
							});
						}
					}

					this.set('markersData', markersData);
				}, { init: false });

				// check the statuses of probes in the measurement and stop measurement if all of them are failed
				this.observe('testResults', (testResults) => {
					for (let i in testResults) {
						if (this.get('testInProgress') && this.get('isInfiniteModeRes') && testResults[i].every(r => r.result.status === PROBE_STATUS_FAILED)) {
							this.stopCurrentTest();

							return;
						}
					}
				});

				// prepare results for gp-results-raw-output and gp-results-table-output, regular or infinite flow
				this.observe('testResults', (testResults) => {
					if (!testResults) { return; }

					let testType = this.get('testReqParams.type');
					let isInfiniteModeRes = this.get('isInfiniteModeRes');
					let sortBy = this.get('sortBy');
					let sortOrder = this.get('sortOrder');
					let rawOutputMode = this.get('rawOutputMode');
					let activeTargetIdx = rawOutputMode ? this.get('activeTargetIdx') : 0;
					let preparedTestResults;

					if (testType === 'ping' && isInfiniteModeRes) {
						preparedTestResults = this.prepareInfiniteResults(testResults);
					} else {
						preparedTestResults = this.prepareRegularResults(testResults);
					}

					preparedTestResults = _.sortGpMeasurementResults(preparedTestResults, sortBy, sortOrder, activeTargetIdx);

					this.set('preparedTestResults', preparedTestResults);
				});

				// set initial screenWidth value
				this.observe('screenWidth', (screenWidth) => {
					if (!screenWidth) {
						this.set('screenWidth', window.innerWidth);
					}
				});

				// handle tooltips positions depending on the screen size
				this.observe('screenWidth', (screenWidth) => {
					let ttPositions = {};

					if (screenWidth >= 1272) {
						ttPositions.targetTtPos = 'top';
						ttPositions.locationTtPos = 'top';
						ttPositions.limitTtPos = 'top';
					} else if (screenWidth >= 768) {
						ttPositions.targetTtPos = 'top';
						ttPositions.locationTtPos = 'right';
						ttPositions.limitTtPos = 'top';
					} else {
						ttPositions.targetTtPos = 'right';
						ttPositions.locationTtPos = 'right';
						ttPositions.limitTtPos = 'right';
					}

					this.set('ttPositions', ttPositions);
				});

				// disable Infinite switch if there is more than one target
				this.observe('mainOptions.target', (target) => {
					if (target.split(',').length > 1) {
						let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

						if (infiniteSwitchEnabled) {
							this.set('notAppliedOpts.packets', '');
							this.set('infiniteSwitchEnabled', false);
							this.applyOptions();
						}
					}
				});

				// add navigation functionality once the Run Test button with dropdown appeared
				this.observe('testInProgress', (testInProgress) => {
					let prevProbesMeasId = this.get('prevProbesMeasId');

					if (prevProbesMeasId && !testInProgress) {
						this.handleDropDownRunTestBtnNav();
					}
				});

				this.observe('showMap', (newValue) => {
					if (!newValue && this.get('originalShowMap')) {
						this.set('transitionMap', false);
					} else {
						// using a deferred observer somehow isn't sufficient here
						setTimeout(() => {
							this.set('transitionMap', true);
						}, 100);
					}
				});
			}
		},
		oncomplete () {
			if (!Ractive.isServer) {
				// run the test if user is pressed Enter inside of any of main options inputs
				let targetInput = this.find('#targetInput');
				let limitInput = this.find('#limitInput');

				let handleEnterBtn = (event) => {
					if (event.key === 'Enter') {
						event.preventDefault();
						this.resetMapAndRunTest();
					}
				};

				targetInput.addEventListener('keypress', handleEnterBtn);
				limitInput.addEventListener('keypress', handleEnterBtn);

				let measurement = this.get('measurement');
				let location = this.get('location');

				if (location && !measurement) {
					// Wait for location-input's onrender to finish (setting swapInputs)
					setTimeout(() => {
						let input = document.querySelector('.location-input-hp .aa-Input');

						if (input) {
							input.select();

							let y = input.getBoundingClientRect().top + window.scrollY;

							window.scrollTo({
								top: y - 225,
								behavior: 'smooth',
							});
						}
					}, 10);
				}
			}
		},
		onunrender () {
			this.set('activeTestRunId', this.get('activeTestRunId') + 1);
			let gmapsIdleListener = this.get('gmapsIdleListener');

			if (gmapsIdleListener) {
				google.maps.event.removeListener(gmapsIdleListener);
				this.set('gmapsIdleListener', null);
			}

			clearTimeout(this.get('runTestBtnDelayTimeout'));
			this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
			this.set('testReqCancelFn', []);
		},
		isActiveTestRun (testRunId) {
			return testRunId === null || testRunId === undefined || testRunId === this.get('activeTestRunId');
		},
		handleRunTestBtn () {
			if (this.get('runTestBtnDisabled')) {
				return;
			}

			if (this.get('testInProgress')) {
				this.stopCurrentTest();
				return;
			}

			this.resetMapAndRunTest();
		},
		stopCurrentTest () {
			let nextTestRunId = this.get('activeTestRunId') + 1;
			let gmapsIdleListener = this.get('gmapsIdleListener');

			if (gmapsIdleListener) {
				google.maps.event.removeListener(gmapsIdleListener);
				this.set('gmapsIdleListener', null);
			}

			this.set('activeTestRunId', nextTestRunId);
			this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
			this.set('testReqCancelFn', []);
			this.set('testInProgress', false);
			this.set('isTestStopped', true);

			this.get('markersData')?.forEach((markerData) => {
				let markerIdx = markerData.clientSideId;

				infoWindows[markerIdx]?.setContent(this.createInfoWindowContent(markerData, markerIdx));
			});

			this.set('runTestBtnText', 'Run Again');
			this.enableRunTestBtn();
		},
		enableRunTestBtn () {
			clearTimeout(this.get('runTestBtnDelayTimeout'));
			this.set('runTestBtnDisabled', false);
			this.set('runTestBtnDelayTimeout', null);
		},
		disableRunTestBtnForDelay () {
			clearTimeout(this.get('runTestBtnDelayTimeout'));
			this.set('runTestBtnDisabled', true);

			this.set('runTestBtnDelayTimeout', setTimeout(() => {
				this.set('runTestBtnDisabled', false);
				this.set('runTestBtnDelayTimeout', null);
			}, 500));
		},
		proceedToTest (prevProbesMeasId) {
			let { type, target, location, limit, ipVersion } = this.get('mainOptions');
			let appliedMeasOpts = this.get('appliedMeasOpts');
			let measurementOpts = _.deepExtend({}, appliedMeasOpts.initPresetOpts, appliedMeasOpts.notPresetOpts);
			let targetsArr = target.split(',').map(target => target.trim());
			let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');
			let testRunId = this.get('activeTestRunId') + 1;

			// create parameters for the measurement request
			let reqParams = {
				type,
				// to get test results in real time
				inProgressUpdates: !!infiniteSwitchEnabled,
			};

			// ipVersion should only be passed if all targets are a domain name and the test type is not 'DNS'
			if (ipVersion && type.toLowerCase() !== 'dns') {
				measurementOpts = {
					...measurementOpts,
					ipVersion,
				};
			}

			reqParams.limit = limit || DEFAULT_LIMIT;

			if (location) {
				reqParams.locations = location.split(',').map(loc => ({ magic: loc }));
			} else {
				this.set('mainOptions.location', INITIAL_MAIN_OPTS_VALUES.location);

				reqParams.locations = [{ magic: INITIAL_MAIN_OPTS_VALUES.location }];
			}

			// since packets field default value is present only for Ping and MTR type
			if (type.toLowerCase() === 'ping' || type.toLowerCase() === 'mtr') {
				reqParams.measurementOptions = {
					// default values used if user does not set them manually
					packets: DEFAULT_PACKETS_AMOUNT,
				};
			} else {
				delete measurementOpts.packets;

				if (type.toLowerCase() === 'http') {
					reqParams.measurementOptions = {
						request: {
							method: measurementOpts?.request?.method || CLIENT_DEFAULT_HTTP_OPTS.request.method,
						},
					};
				}
			}

			if (Object.keys(measurementOpts).length) {
				reqParams.measurementOptions = {
					...reqParams.measurementOptions || {},
					...measurementOpts,
				};
			}

			// clear all data from the previous test, close additional options menu, show spinner, set up Map's data etc.
			this.set('testResults', null);
			this.set('markersData', null);
			this.set('probesResponse', null);
			this.set('showMeasurementOpts', false);
			this.set('testInProgress', true);
			this.set('measurementErrMsg', null);
			this.set('targetsArr', targetsArr);
			this.set('testReqParams', { ...reqParams, target: targetsArr[0] });
			this.set('shareResFlow', false);
			this.set('shareResHeaderData', null);
			this.set('mobileShareResHeaderData', null);
			this.set('realTimeTestResResponse', null);
			this.set('activeTargetIdx', 0);
			this.set('measurementsMetadata', null);
			this.set('showCreditsErrorBar', false);
			this.set('infiniteMeasIds', []);
			this.set('isTestStopped', false);
			this.set('showCreditsData', true);
			this.set('prevProbesMeasId', null);
			this.set('preparedTestResults', []);
			this.set('rateCreditsData', null);
			this.set('probesMaxTiming', type.toLowerCase() === 'http' ? 1000 : 200);
			this.set('_measurementOgDescription', null);
			this.set('showingNetworkLogos', false);
			this.set('activeTestRunId', testRunId);
			this.set('testReqCancelFn', []);
			this.expandAllRawOutput();

			// if it is infinite/multi-endpoint measurement then we should show TableOutput by default
			// otherwise leave prev value set by user
			if (infiniteSwitchEnabled || targetsArr.length >= 2) {
				this.set('rawOutputMode', false);
			}

			// is designed to prevent the way the test results are displayed from changing when the user toggles the infinite switch
			this.set('isInfiniteModeRes', infiniteSwitchEnabled);
			let titleData = targetsArr.map(target => ({ ...reqParams, type: type.toLowerCase(), target }));

			// re-use probes case
			if (prevProbesMeasId) {
				reqParams = {
					...reqParams,
					locations: prevProbesMeasId,
				};
			}

			// run Infinite type of the measurement
			if (type === 'ping' && targetsArr.length === 1 && infiniteSwitchEnabled) {
				this.postInfiniteGlobalpingMeasurement({ reqParams, target: targetsArr[0], testRunId, measurementTitle: getMeasurementTitle(titleData) });

				return;
			}

			// common type of the measurement
			http.postGlobalpingMeasurement({ ...reqParams, target: targetsArr[0] }, RATE_LIMIT_HEADERS).then((res) => {
				if (!this.isActiveTestRun(testRunId)) {
					return;
				}

				// set measurement ID for re-use probes case
				this.set('prevProbesMeasId', res.response.id);

				// Update the URL.
				this.set('measurement', res.response.id);
				this.set('_measurementOgTitle', getMeasurementTitle(titleData.slice(0, 1)));

				this.set('testReqParams.id', res.response.id);

				this.set('measurementsMetadata', {
					0: {
						target: targetsArr[0],
						measurementId: res.response.id,
					},
				});

				// set response headers for gp-credits/gp-credits-message
				this.set('rateCreditsData', { ...res.responseHeaders });

				if (targetsArr[1]) {
					let secReqParams;

					// prepare params depending whether there is prevProbesMeasId or not
					if (prevProbesMeasId) {
						secReqParams = { locations: res.response.id, ...reqParams, target: targetsArr[1] };
					} else {
						secReqParams = { ...reqParams, locations: res.response.id, target: targetsArr[1] };
					}

					http.postGlobalpingMeasurement(secReqParams, RATE_LIMIT_HEADERS).then((res1) => {
						if (!this.isActiveTestRun(testRunId)) {
							return;
						}

						let combinedHeaders = { ...res1.responseHeaders };

						[
							'x-ratelimit-consumed',
							'x-credits-consumed',
							'x-request-cost',
						].forEach((header) => {
							combinedHeaders[header] = (Number(res.responseHeaders[header]) || 0) + (Number(res1.responseHeaders[header]) || 0);
						});

						// set response headers for gp-credits/gp-credits-message
						this.set('rateCreditsData', combinedHeaders);

						this.set('measurementsMetadata[1]', {
							target: targetsArr[1],
							measurementId: res1.response.id,
						});

						this.getTestMeasurementById({ measurementId: res.response.id, testRunId });
						this.getTestMeasurementById({ measurementId: res1.response.id, resNumber: 1, testRunId });
						this.set('showMap', this.get('originalShowMap'));

						// Update the URL without creating a new history entry.
						app.router.replaceQueryParam('measurement', `${this.get('measurement')},${res1.response.id}`);
						this.set('_measurementOgTitle', getMeasurementTitle(titleData));
					}).catch((err) => {
						if (!this.isActiveTestRun(testRunId)) {
							return;
						}

						this.set('showMap', this.get('originalShowMap'));

						this.getTestMeasurementById({ measurementId: res.response.id, testRunId }).then(() => {
							if (!this.isActiveTestRun(testRunId)) {
								return;
							}

							this.handlePostGPMeasError(err, true);
							this.set('targetsArr', [ targetsArr[0] ]);
						});
					});
				} else {
					this.getTestMeasurementById({ measurementId: res.response.id, testRunId });
					this.set('showMap', this.get('originalShowMap'));
				}
			}).catch((err) => {
				if (!this.isActiveTestRun(testRunId)) {
					return;
				}

				this.set('measurement', null);
				this.set('_measurementOgTitle', null);
				this.handlePostGPMeasError(err);
			});
		},
		applyOptions () {
			// Clear the port input when the selected protocol does not support it
			if (this.get('disablePort')) {
				this.set('notAppliedOpts.port', '');
			}

			// filter opts from empty values
			let filterOptsFromEmptyOne = opts => Object.keys(opts).reduce((res, key) => {
				if (typeof opts[key] === 'object') {
					res[key] = Object.keys(opts[key]).reduce((secRes, secKey) => {
						if (opts[key][secKey] !== '') {
							secRes[secKey] = opts[key][secKey];
						}

						return secRes;
					}, {});
				} else if (opts[key] !== '') {
					res[key] = opts[key];
				}

				return res;
			}, {});

			let { type } = this.get('mainOptions');
			let currOptsName = `${type.toLowerCase()}Opts`;
			let initPresetOpts = filterOptsFromEmptyOne(this.get(currOptsName));
			let notPresetOpts = filterOptsFromEmptyOne(this.get('notAppliedOpts'));
			let opts = {
				initPresetOpts,
				notPresetOpts,
			};

			this.set('appliedMeasOpts', opts);

			this.countModifiedMeasurementOpts(type, initPresetOpts, notPresetOpts);

			this.set('showMeasurementOpts', false);
		},
		initMap () {
			let mq = window.matchMedia('(min-width: 768px)');

			map = new google.maps.Map(this.find('#gp-map'), {
				zoom: MAP_ZOOM_REG,
				center: MAP_CENTER_REG,
				mapTypeId: 'roadmap',
				draggableCursor: 'default',
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				minZoom: MAP_MIN_ZOOM,
				maxZoom: MAP_MAX_ZOOM,
				mapId: 'ce04bbf9d49b6f34',
			});

			if (mq.matches) {
				map.setCenter(MAP_CENTER_ALT);
				map.setZoom(MAP_ZOOM_ALT);
			}

			this.set('clusterRadius', this.getClusterRadius());

			// handle map changes on zoom
			map.addListener('zoom_changed', () => {
				// close all IWs on zoom
				infoWindows.forEach(iw => iw.close());
				probesInfoWindows.forEach(piw => piw.close());

				this.despiderifyMapMarkers(mapMarkers);

				// scale cluster's markers size on zoom
				probesMarkers.forEach((m) => {
					let { svgWidth, svgHeight } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);

					m.content.style.width = `${svgWidth}px`;
					m.content.style.height = `${svgHeight}px`;
				});

				let nextClusterRadius = this.getClusterRadius();

				if (
					this.get('probesResponse')
					&& !this.get('shareResFlow')
				) {
					this.set('nextClusterRadius', nextClusterRadius === this.get('clusterRadius') ? null : nextClusterRadius);
				}
			});

			map.addListener('idle', () => {
				this.refreshProbeClusters();
			});

			// draw probes Clusters or clear the map from them
			this.observe('probesResponse', (probesResponse) => {
				// when we run a new test probesResponse will be cleared ergo we should clear the map from the probesClusters
				if (probesResponse === null) {
					this.clearProbesClusters();
				// display probesCLusters on the map only when we have probesData and not in share-results-flow
				} else if (probesResponse && !this.get('shareResFlow')) {
					this.updateClusters(probesResponse);
				}
			});

			// check whether we should clear the Map from the markers or update them
			this.observe('markersData', (markersData, prevMarkersData) => {
				if (markersData === null) {
					this.clearTestResponseMarkers();
				} else if (JSON.stringify(markersData) !== JSON.stringify(prevMarkersData)) {
					// clear stale markers (happens on client-side navigation)
					if (!prevMarkersData && (infoWindows.length || mapMarkers.length)) {
						this.clearTestResponseMarkers();
					}

					// update Markers on the map (replace or add new) if Markers data is different
					this.updateMarkers(markersData, prevMarkersData);
				}
			});

			this.enableRunTestBtn();
			this.set('gmapsReady', true);
		},
		updateMarkers (markersData, prevMarkersData) {
			markersData.forEach((markerData) => {
				let markerIdToReplace = null;
				let currentMarkerIdx = markerData.clientSideId;

				// check if the new Marker is the old one but with a timing value
				// and get Marker index to replace it later on the Map
				// get index for every Marker we draw or redraw on the map to provide proper work of InfoWindows, Results and Actions etc.
				if (prevMarkersData) {
					// stop once we found the match to get proper currentMarkerIdx
					prevMarkersData.every((pmd) => {
						if (
							pmd.clientSideId === markerData.clientSideId
							&& markerData.timings !== null
							&& markerData.timings.every(t => t)
						) {
							markerIdToReplace = pmd.clientSideId;
							currentMarkerIdx = pmd.clientSideId;

							return false;
						}

						return true;
					});
				}

				// create a new marker and add it to the map or update existing with new data
				if (markerIdToReplace !== null) {
					let prevMarkerData = prevMarkersData[markerIdToReplace];
					let markerStatusChanged = !_.isEqual(markerData.timings, prevMarkerData.timings)
						|| !_.isEqual(markerData.failureSources, prevMarkerData.failureSources);

					mapMarkers.forEach((mm, mmIdx) => {
						if (markerIdToReplace === mmIdx && markerStatusChanged) {
							this.updateMapMarkerWithIW(mm, markerData, currentMarkerIdx);
						}
					});
				} else if (!mapMarkers[markerData.clientSideId]) {
					// collect markers added to the map
					this.createMapMarkerWithIW(markerData, currentMarkerIdx);
				}
			});

			// close IWs on click on Map
			google.maps.event.addListener(map, 'click', () => {
				infoWindows.forEach(iw => iw.close());

				this.despiderifyMapMarkers(mapMarkers);
			});
		},
		updateClusters (probes) {
			let clusterRadius = this.getClusterRadius();
			this.set({
				clusterRadius,
				nextClusterRadius: null,
			});

			let preparedMarkers = Object.keys(probes).map((key) => {
				let [ lat, lng ] = key.split(', ');
				let marker = probesMarkers.find(pm => pm.position.lat === lat && pm.position.lng === lng);

				if (!marker) {
					marker = this.createMapClusterMarkerWithIW(key, probes[key]);
					probesMarkers.push(marker);
				}

				return marker;
			});

			// eslint-disable-next-line no-undef
			let probeCluster = new markerClusterer.MarkerClusterer({
				markers: preparedMarkers,
				map,
				renderer: {
					render ({ markers, position }) {
						let totalCustomNumber = markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
						let clusterSvg = window.btoa(`<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 68 68" fill="none">
							<g clip-path="url(#a)">
							<path fill="url(#b)" d="M30 2.31a8 8 0 0 1 8 0l21.445 12.38a8 8 0 0 1 4 6.929V46.38a8 8 0 0 1-4 6.928L38 65.691a8 8 0 0 1-8 0L8.555 53.309a8 8 0 0 1-4-6.928V21.62a8 8 0 0 1 4-6.928z"/>
							<path stroke="#69E7C8" stroke-width="1.5" d="M30.375 4.959a7.25 7.25 0 0 1 7.25 0L57.338 16.34a7.25 7.25 0 0 1 3.625 6.279V45.38a7.25 7.25 0 0 1-3.625 6.279L37.625 63.04a7.25 7.25 0 0 1-7.25 0L10.662 51.66a7.25 7.25 0 0 1-3.625-6.279V22.62a7.25 7.25 0 0 1 3.625-6.279L30.375 4.96Z"/>
							</g>
							<text x="34" y="40" fill="#fff" font-family="Lexend, sans-serif" font-size="16px" font-weight="600" text-anchor="middle">
							${totalCustomNumber}
							</text>
							<defs>
							<linearGradient id="b" x1="34" x2="34" y1="0" y2="68" gradientUnits="userSpaceOnUse">
							<stop stop-color="#17D4A7"/>
							<stop offset="1" stop-color="#17D4A7"/>
							</linearGradient>
							<clipPath id="a">
							<path fill="#fff" d="M0 0h68v68H0z"/>
							</clipPath>
							</defs>
						</svg>`);
						let clusterDiv = document.createElement('div');
						let clusterImg = document.createElement('img');

						clusterDiv.style.position = 'relative';
						clusterDiv.style.width = '54px';
						clusterDiv.style.height = '54px';
						clusterDiv.style.background = 'transparent';
						clusterImg.src = `data:image/svg+xml;base64,${clusterSvg}`;
						clusterImg.width = '54';
						clusterImg.height = '54';
						clusterDiv.appendChild(clusterImg);

						return new google.maps.marker.AdvancedMarkerElement({
							position,
							content: clusterDiv,
						});
					},
				},
				// eslint-disable-next-line no-undef
				algorithm: new markerClusterer.SuperClusterAlgorithm({
					radius: clusterRadius,
				}),
			});

			mapProbesClusters.push(probeCluster);

			google.maps.event.addListener(map, 'click', () => {
				probesInfoWindows.forEach(piw => piw.close());
			});
		},
		refreshProbeClusters () {
			let probesResponse = this.get('probesResponse');
			let nextClusterRadius = this.get('nextClusterRadius');

			if (
				!probesResponse
				|| this.get('shareResFlow')
				|| !nextClusterRadius
				|| nextClusterRadius === this.get('clusterRadius')
			) {
				return;
			}

			this.set('clusterRadius', nextClusterRadius);
			this.clearProbesClusters();
			this.updateClusters(probesResponse);
		},
		getClusterRadius () {
			if (map.zoom <= MAP_ZOOM_REG) {
				return 120;
			}

			return 200;
		},
		clearTestResponseMarkers () {
			infoWindows.forEach(iw => iw.close());
			mapMarkers.forEach(mm => mm.setMap(null));
			infoWindows = [];
			mapMarkers = [];
		},
		clearProbesClusters () {
			probesInfoWindows.forEach(piw => piw.close());
			mapProbesClusters.forEach(pc => pc.setMap(null));
			probesMarkers.forEach(pm => pm.map = null);
			probesMarkers = [];
			probesInfoWindows = [];
			mapProbesClusters = [];
		},
		collapseCmdBlock () {
			let element = document.querySelector('.gp_join-network_cmd-block_command');

			requestAnimationFrame(() => {
				element.style.height = `${element.scrollHeight}px`;

				requestAnimationFrame(() => {
					element.style.height = '56px';
				});
			});
		},
		expandCmdBlock () {
			let element = document.querySelector('.gp_join-network_cmd-block_command');

			requestAnimationFrame(() => {
				element.style.height = '56px';

				requestAnimationFrame(() => {
					element.style.height = `${element.scrollHeight}px`;
				});
			});
		},
		handleSeeResults (clientSideId) {
			let el;

			if (this.get('rawOutputMode')) {
				el = this.find(`.c-gp-results-raw-output_list_item.item-id-${clientSideId}`);
			} else {
				el = this.find(`.c-gp-results-table-output .results-table_row.row-num-${clientSideId}`);
			}

			// this prop will be passed to c-gp-results-raw-output in order for it to show the specific result element if it was hidden
			this.set('scrolledToResId', clientSideId);

			if (el) {
				el.scrollIntoView({ behavior: 'smooth' });
			}
		},
		initResponseBodyCharWidth () {
			let measureNode = document.createElement('span');
			measureNode.style.position = 'absolute';
			measureNode.style.visibility = 'hidden';
			measureNode.style.whiteSpace = 'pre';
			measureNode.style.pointerEvents = 'none';
			measureNode.style.fontFamily = '"Source Code Pro", monospace';
			measureNode.style.fontSize = '13px';
			measureNode.style.lineHeight = '21px';
			measureNode.textContent = 'M';
			document.body.appendChild(measureNode);

			let width = measureNode.getBoundingClientRect().width;
			measureNode.remove();
			this.set('responseBodyCharWidth', width > 0 ? width : 7);
		},
		getRawOutputCharsPerLine () {
			let listEl;
			let outputHorizontalPadding = 32 * 2;
			let outputListMargin = 24 * 2;
			let windowWidth = window.innerWidth;
			let FALLBACK_CHAR_WIDTH = 7;

			try {
				listEl = this.find('.c-gp-results-raw-output_list');
			} catch {
				let contentWidth = Math.min(1240, windowWidth - outputListMargin - outputHorizontalPadding);
				return Math.floor(contentWidth / FALLBACK_CHAR_WIDTH);
			}

			let listWidth = listEl?.getBoundingClientRect?.().width || 0;
			let contentWidth = Math.max(1, listWidth - outputHorizontalPadding);

			if (!listWidth) {
				contentWidth = Math.min(1240, windowWidth - outputListMargin - outputHorizontalPadding);
			}

			let charWidth = this.get('responseBodyCharWidth') || FALLBACK_CHAR_WIDTH;
			return Math.max(1, Math.floor(contentWidth / charWidth));
		},
		collapseAllRawOutput ({ responseBodyOnly = false } = {}) {
			let ids = this.get('preparedTestResults').map(result => result.clientSideId);

			this.set('hiddenResponseBodies', {
				0: [ ...ids ],
				1: [ ...ids ],
			});

			if (!responseBodyOnly) {
				this.set(`hiddenTestResults`, {
					0: [ ...ids ],
					1: [ ...ids ],
				});
			}
		},
		expandAllRawOutput ({ withResponseBody = false, responseBodyOnly = false } = {}) {
			if (withResponseBody || responseBodyOnly) {
				this.set(`hiddenResponseBodies`, {
					0: [],
					1: [],
				});
			} else {
				this.collapseAllRawOutput({ responseBodyOnly: true });
			}

			if (!responseBodyOnly) {
				this.set('hiddenTestResults', {
					0: [],
					1: [],
				});
			}
		},
		getTestMeasurementById ({
			measurementId,
			resNumber = '0',
			isShareResCase = false,
			isFirstShareReq = false,
			isLastShareReq = false,
			isInfiniteMeas = false,
			reqParams = {},
			testRunId = null,
		}) {
			return new Promise((resolve, reject) => {
				let cancelled = false;
				let timeout = null;

				let cancel = () => {
					cancelled = true;
					clearTimeout(timeout);
					timeout = null;
				};

				let fetch = () => {
					if (cancelled || !this.isActiveTestRun(testRunId)) {
						resolve();
						return;
					}

					http.getGlobalpingMeasurement(measurementId).then((testRes) => {
						if (cancelled || !this.isActiveTestRun(testRunId)) {
							cancel();
							resolve();
							return;
						}

						let ipVersion = testRes.measurementOptions?.ipVersion;

						if (isShareResCase) {
							let currentTargets = this.get('mainOptions.target');
							let currTargetsArr = _.removeDuplicatedTargets(currentTargets ? currentTargets.split(',') : []);
							let updTargetsArr = currTargetsArr.indexOf(testRes.target) < 0 ? [ ...currTargetsArr, testRes.target ] : currTargetsArr;

							this.set('mainOptions.target', updTargetsArr.join(','));

							// if infinite measurement we need to set targetsArr ASAP since we know there is only one target
							if (isInfiniteMeas) {
								this.set('targetsArr', updTargetsArr);
							}

							// only the first target's response returns locations
							if (isFirstShareReq) {
								let magicValue = testRes.locations?.reduce((res, loc) => {
									if (loc.magic) {
										res += res.length ? `, ${loc.magic}` : loc.magic;

										return res;
									}

									return res;
								}, '');

								this.set('mainOptions.location', magicValue);
							}

							if (isLastShareReq) {
								this.set('targetsArr', updTargetsArr);
								this.set('shareResHeaderData', `Showing results from ${_.formatDateTime(new Date(testRes.createdAt))}`);
								this.set('mainOptions.type', this.translateTestTypeName(testRes.type));
								this.set('mainOptions.limit', testRes.limit || DEFAULT_LIMIT);

								this.set('mobileShareResHeaderData', {
									date: _.formatDateTime(new Date(testRes.createdAt)),
									target: updTargetsArr.join(', '),
									type: this.translateTestTypeName(testRes.type),
								});

								// handle map max timing for HTTP measurement
								if (testRes.type.toLowerCase() === 'http') {
									this.set('probesMaxTiming', 1000);
								}

								// ipVersion (target ip-type-switch) came with the measurementOptions but should be treated as the mainOptions
								if (testRes.measurementOptions?.ipVersion) {
									// if there is one target and it has IPv6 format (not a domain name) we shouldn't set ipVersion
									if (updTargetsArr.length !== 1 || !ipRegex.v6({ exact: true, allowBrackets: true }).test(updTargetsArr[0])) {
										this.set('mainOptions.ipVersion', testRes.measurementOptions.ipVersion);
									}

									delete testRes.measurementOptions.ipVersion;
								}

								let defaultAPIOpts = this.getDefaultAPIMeasOptsByTestName(testRes.type);
								let combinedOptions = _.deepExtend({}, defaultAPIOpts, testRes.measurementOptions);
								let receivedInitPresetOpts = this.filterForInitPresetOpts(defaultAPIOpts, combinedOptions);
								let receivedNotPresetOpts = this.filterForNotPresetOpts(defaultAPIOpts, combinedOptions);

								this.set('notAppliedOpts', receivedNotPresetOpts);
								this.set(`${testRes.type.toLowerCase()}Opts`, receivedInitPresetOpts);
								this.applyOptions();

								if (!isInfiniteMeas) {
									this.set('runTestBtnText', 'Run Again');
								}

								// clear qsMeasurementIdsArr so the mainOptions.type observer could work now
								this.set('qsMeasurementIdsArr', []);
							}
						}

						let isTestStopped = this.get('isTestStopped');

						// check if infinite measurement was stopped
						if (isInfiniteMeas && isTestStopped) {
							cancel();
							resolve();
						}

						// prepare and set request params to pass them to gp-test-results
						let testReqParams = JSON.parse(JSON.stringify(testRes));

						delete testReqParams.results;
						delete testReqParams.status;
						delete testReqParams.updatedAt;
						delete testReqParams.createdAt;

						testReqParams = {
							inProgressUpdates: isInfiniteMeas,
							limit: DEFAULT_LIMIT,
							...testReqParams,
							// follow-up measurements reuse the first measurement's probes, so keep its locations instead of the measurement ID
							...Number(resNumber) > 0 && { locations: this.get('testReqParams.locations') },
							measurementOptions: {
								trace: false,
								...testReqParams.measurementOptions,
								...ipVersion && { ipVersion },
							},
						};

						// set testReqParams to pass them to c-gp-results-raw-output
						this.set('testReqParams', testReqParams);

						// collect IDs of each target's measurement response
						let updMeasMetadata = {
							...this.get('measurementsMetadata'),
							[resNumber]: {
								target: testReqParams.target,
								measurementId: testReqParams.id,
							},
						};

						this.set('measurementsMetadata', updMeasMetadata);

						// set the local/client time of the response received
						let currentTimestamp = Date.now();
						let testResUpd = {
							...testRes,
							clientSideStartedAt: currentTimestamp,
							clientSideUpdatedAt: currentTimestamp,
						};

						// should be after the mainOptions.type was set
						this.set(`realTimeTestResResponse[${resNumber}]`, testResUpd);

						if (isShareResCase) {
							let responses = this.get('realTimeTestResResponse').filter(Boolean);
							this.set('_measurementOgTitle', getMeasurementTitle(isInfiniteMeas ? responses.slice(0, 1) : responses));
						}

						// handle infinite test flow, once at least one probe is finished we should run measurement again
						if (this.get('shareResFlow') === false && isInfiniteMeas && testRes.results.some(r => r.result.status === 'finished')) {
							let infiniteMeasIds = this.get('infiniteMeasIds');

							if (!infiniteMeasIds.includes(testRes.id)) {
								this.set('infiniteMeasIds', [ ...infiniteMeasIds, testRes.id ]);

								if (!isTestStopped) {
									this.postInfiniteGlobalpingMeasurement({
										reqParams,
										target: testRes.target,
										isInfiniteMeas: true,
										resNumber: infiniteMeasIds.length + 1,
										testRunId,
									});
								}
							}
						}

						resolve(testRes);
					}).catch((e) => {
						if (cancelled || !this.isActiveTestRun(testRunId)) {
							cancel();
							resolve();
							return;
						}

						let responseStatusCode = e?.responseStatusCode;
						let isRequestError = typeof responseStatusCode === 'number';

						let isRetryableRequestError = isRequestError && (
							responseStatusCode === 0
							|| responseStatusCode === 408
							|| responseStatusCode === 429
							|| responseStatusCode >= 500
						);

						if (isRetryableRequestError) {
							return;
						}

						this.stopCurrentTest();

						if (!isRequestError) {
							reject(e);
							return;
						}

						if (isShareResCase) {
							let errorMessage = responseStatusCode === 404
								? 'This measurement has expired!'
								: 'An unexpected error occurred. Please try again later.';

							this.set('shareResHeaderData', errorMessage);
							this.set('runTestBtnText', 'Run Test');

							if (responseStatusCode === 404) {
								this.scrollMapIntoView();
							}

							reject(e);
							return;
						}

						this.set('measurementErrMsg', 'An unexpected error occurred. Please try again later.');
						resolve();
					}).finally(() => {
						if (!cancelled && this.isActiveTestRun(testRunId)) {
							timeout = setTimeout(fetch, 500);
						}
					});
				};

				this.set(`testReqCancelFn[${resNumber}]`, cancel);
				fetch();
			});
		},
		handleProbesResponse (response) {
			this.set('rawProbes', response);

			let { totalCities, totalCountries } = response.reduce((res, item) => {
				if (!res.citiesList.includes(item.location.city)) {
					res.citiesList.push(item.location.city);
				}

				if (!res.countriesList.includes(item.location.country)) {
					res.countriesList.push(item.location.country);
				}

				res.totalCities = res.citiesList.length;
				res.totalCountries = res.countriesList.length;

				return res;
			}, { citiesList: [], countriesList: [], totalCities: 0, totalCountries: 0 });

			this.animate('totalProbes', response.length, { duration: 1500 });
			this.animate('totalCities', totalCities, { duration: 1500 });
			this.animate('totalCountries', totalCountries, { duration: 1500 });

			if (this.get('activeTestRunId') === 0) {
				this.set('probesResponse', this.groupProbes(response));
			}
		},
		translateTestTypeName (name) {
			switch (name.toLowerCase()) {
				case 'ping':
				case 'traceroute':
					return name.toLowerCase();
				case 'dns':
				case 'mtr':
				case 'http':
					return name.toUpperCase();
			}
		},
		getDefaultClientMeasOptsByTestName (name) {
			let res;

			switch (name.toLowerCase()) {
				case 'ping':
					res = this.get('infiniteSwitchEnabled') ? { ...CLIENT_DEFAULT_PING_OPTS, packets: INFINITE_MEASUREMENT_PACKETS } : CLIENT_DEFAULT_PING_OPTS; break;
				case 'traceroute':
					res = CLIENT_DEFAULT_TRACEROUTE_OPTS; break;
				case 'dns':
					res = CLIENT_DEFAULT_DNS_OPTS; break;
				case 'mtr':
					res = CLIENT_DEFAULT_MTR_OPTS; break;
				case 'http':
					res = CLIENT_DEFAULT_HTTP_OPTS; break;
			}

			// create deep copy to avoid mutations
			return JSON.parse(JSON.stringify(res));
		},
		getDefaultAPIMeasOptsByTestName (name) {
			let res;

			switch (name.toLowerCase()) {
				case 'ping':
					res = API_DEFAULT_PING_OPTS; break;
				case 'traceroute':
					res = API_DEFAULT_TRACEROUTE_OPTS; break;
				case 'dns':
					res = API_DEFAULT_DNS_OPTS; break;
				case 'mtr':
					res = API_DEFAULT_MTR_OPTS; break;
				case 'http':
					res = API_DEFAULT_HTTP_OPTS; break;
			}

			// create deep copy to avoid mutations
			return JSON.parse(JSON.stringify(res));
		},
		handleToggleMeasOpts () {
			if (this.get('testInProgress')) { return; }

			let prevValue = this.get('showMeasurementOpts');

			this.set('showMeasurementOpts', !prevValue);

			// if opts were not applied we should em reset to default or to prev applied state on closing of MeasOpts dropdown
			if (prevValue === true) {
				let testType = this.get('mainOptions.type');
				let appliedMeasOpts = this.get('appliedMeasOpts');
				let defaultOpts = this.getDefaultClientMeasOptsByTestName(testType);

				if (Object.keys(appliedMeasOpts).length) {
					this.set(`${testType.toLowerCase()}Opts`, { ...JSON.parse(JSON.stringify(appliedMeasOpts.initPresetOpts)) });
					this.set('notAppliedOpts', { ...JSON.parse(JSON.stringify(appliedMeasOpts.notPresetOpts)) });
				} else {
					this.set(`${testType.toLowerCase()}Opts`, defaultOpts);
					this.set('notAppliedOpts', {});
				}
			}
		},
		countModifiedMeasurementOpts (type, initPresetOpts, notPresetOpts) {
			let defaultOpts = this.getDefaultClientMeasOptsByTestName(type);
			let modifiedMeasOptsCnt = Object.keys(notPresetOpts).reduce((cnt, key) => {
				if (typeof notPresetOpts[key] === 'object') {
					if (key === 'request' && notPresetOpts[key].headers) {
						// each header should be treated as 1 modified option
						let headersCnt = Object.keys(notPresetOpts[key].headers).length;
						let otherPropsCnt = Object.keys(notPresetOpts[key]).length - 1; // -1 for headers

						return cnt + headersCnt + otherPropsCnt;
					}

					return cnt + Object.keys(notPresetOpts[key]).length;
				} else if (defaultOpts[key] !== notPresetOpts[key]) {
					return ++cnt;
				}

				return cnt;
			}, 0);

			Object.keys(defaultOpts).forEach((key) => {
				if (typeof defaultOpts[key] === 'object') {
					Object.keys(defaultOpts[key]).forEach((secKey) => {
						if (defaultOpts[key][secKey] !== initPresetOpts[key][secKey]) {
							modifiedMeasOptsCnt++;
						}
					});
				} else if (defaultOpts[key] !== initPresetOpts[key] && defaultOpts[key] !== notPresetOpts[key]) {
					modifiedMeasOptsCnt++;
				}
			});

			this.set('modifiedMeasOptsCnt', modifiedMeasOptsCnt);
		},
		resetMapAndRunTest (prevProbesMeasId = null) {
			this.disableRunTestBtnForDelay();
			this.get('testReqCancelFn')?.forEach(cancel => cancel?.());
			this.set('testReqCancelFn', []);
			this.set('measurementsMetadata', null);
			this.set('testInProgress', true);

			let mq = window.matchMedia('(min-width: 768px)');

			if (mq.matches) {
				map.setCenter(MAP_CENTER_ALT);
				map.setZoom(MAP_ZOOM_ALT);
			} else {
				map.setCenter(MAP_CENTER_REG);
				map.setZoom(MAP_ZOOM_REG);
			}

			// once zoom is ended the idle event will be fired
			let listener = map.addListener('idle', () => {
				this.proceedToTest(prevProbesMeasId);
				// remove listener to avoid unintended test runs while zoom
				google.maps.event.removeListener(listener);
				this.set('gmapsIdleListener', null);
			});

			this.set('gmapsIdleListener', listener);
		},
		filterForInitPresetOpts (defaultOpts, optionsToFilter) {
			return Object.keys(optionsToFilter).reduce((res, key) => {
				if (Object.hasOwn(defaultOpts, key)) {
					if (typeof defaultOpts[key] === 'object') {
						res = {
							...res,
							[key]: this.filterForInitPresetOpts(defaultOpts[key], optionsToFilter[key]),
						};
					} else {
						res = {
							...res,
							[key]: optionsToFilter[key],
						};
					}
				}

				return res;
			}, {});
		},
		filterForNotPresetOpts (defaultOpts, optionsToFilter) {
			return Object.keys(optionsToFilter).reduce((res, key) => {
				if (Object.hasOwn(defaultOpts, key)) {
					if (typeof optionsToFilter[key] === 'object') {
						res = {
							...res,
							[key]: this.filterForNotPresetOpts(defaultOpts[key], optionsToFilter[key]),
						};
					}
				} else {
					res = {
						...res,
						[key]: optionsToFilter[key],
					};
				}

				return res;
			}, {});
		},
		zoomToResults (locations) {
			setTimeout(() => {
				// do not zoom if test was done for the World.
				if (
					!locations
					|| (
						locations.length === 1
							&& (locations[0].magic.toLowerCase() === 'world' || locations[0].magic === '')
					)
				) {
					return;
				}

				// limit max zoom temp to avoid unnecessary zooming
				map.setOptions({ maxZoom: 6 });

				let bounds = new google.maps.LatLngBounds();

				mapMarkers.forEach((mm) => {
					bounds.extend(mm.position);
				});

				google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
					map.panTo(bounds.getCenter());
					// restore default zoom
					map.setOptions({ maxZoom: MAP_MAX_ZOOM });
				});

				map.fitBounds(bounds);
			}, 400);
		},
		getProbesData () {
			dataCache.getCache('probesResponse', 60 * 1000, http.fetchGlobalpingProbes)
				.then(value => this.handleProbesResponse(value))
				.catch((error) => {
					console.error('Failed to fetch probes', error);
				});
		},
		scrollMapIntoView () {
			let mapBlockEl = this.find('.gp_map-block');
			let mobileTestDetails = this.find('.gp_map-block_test-details');

			if (mobileTestDetails?.checkVisibility?.()) {
				mobileTestDetails.scrollIntoView({
					behavior: 'smooth',
				});
			} else {
				mapBlockEl.scrollIntoView({
					behavior: 'smooth',
				});
			}
		},
		updateMapMarkerWithIW (marker, markerData, currentMarkerIdx) {
			let updSvg = this.createMapMarkerSvg(markerData);
			let currIw = infoWindows[currentMarkerIdx];

			marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${updSvg}')`;

			currIw.setContent(this.createInfoWindowContent(markerData, currentMarkerIdx));
		},
		createMapMarkerWithIW (markerData, currentMarkerIdx) {
			// create Popup element which will be shown on click on the marker
			let infoWindow = new google.maps.InfoWindow();

			// create svg to use as a Marker icon
			let svg = this.createMapMarkerSvg(markerData);
			let locationId = markerData.clientSideId;

			// add listener to IW for Results and Actions button
			google.maps.event.addListener(infoWindow, 'domready', () => {
				let clickableEl = document.getElementById(`iw-${currentMarkerIdx}`);
				let hasListener = clickableEl.dataset.hasListener;

				if (!hasListener) {
					clickableEl.addEventListener('click', () => {
						this.handleSeeResults(locationId);
						clickableEl.dataset.hasListener = true;
					});
				}
			});

			// collect IWs
			infoWindows.push(infoWindow);
			infoWindow.setContent(this.createInfoWindowContent(markerData, currentMarkerIdx));

			let markerContent = document.createElement('div');
			markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
			markerContent.style.width = `${DEFAULT_MARKER_DIMENSIONS}px`;
			markerContent.style.height = `${DEFAULT_MARKER_DIMENSIONS}px`;
			markerContent.style.backgroundRepeat = 'no-repeat';
			markerContent.style.backgroundPosition = 'center';
			markerContent.style.backgroundSize = 'contain';

			// create a new Marker
			let marker = new google.maps.marker.AdvancedMarkerElement({
				map,
				content: markerContent,
				position: { lat: markerData.lat, lng: markerData.lng },
				zIndex: 1,
			});

			// keep original markers positions
			originalMapMarkersPos.set(marker, marker.position);

			mapMarkers.push(marker);

			// open IW on click, close all other IWs, handle markers spiderifying
			marker.addListener('click', () => {
				infoWindows.forEach(iw => iw.close());

				// check if marker is overlapping with other and should be spiderified
				if (this.shouldMapMarkersSpiderify(marker, mapMarkers, map) && marker.isSpiderPart !== true) {
					// despiderify markers
					this.despiderifyMapMarkers(mapMarkers);
					// spiderify overlapping markers
					this.spiderifyMapMarkers(marker, mapMarkers, map);
				} else {
					// open InfoWindow if marker is already spiderified or do not needed to be
					infoWindow.open({ map, anchor: marker });
				}
			});
		},
		async getMultipleTestMeasurementById (idsArr, isInfiniteMeas = false) {
			for (let i = 0; i < idsArr.length; i++) {
				await this.getTestMeasurementById({
					measurementId: idsArr[i],
					resNumber: i,
					isShareResCase: true,
					isFirstShareReq: i === 0,
					isLastShareReq: idsArr.length - 1 === i,
					isInfiniteMeas,
				});
			}
		},
		postInfiniteGlobalpingMeasurement ({ reqParams, target, isInfiniteMeas = true, resNumber = 0, testRunId = null, measurementTitle = null }) {
			this.set('runTestBtnText', 'Stop');

			http.postGlobalpingMeasurement({ ...reqParams, target }, RATE_LIMIT_HEADERS).then((res) => {
				if (!this.isActiveTestRun(testRunId)) {
					return;
				}

				// set response headers for gp-credits/gp-credits-message
				this.set('rateCreditsData', { ...res.responseHeaders, probesCount: res.response.probesCount });

				// set measurement ID for re-use probes case
				this.set('prevProbesMeasId', res.response.id);

				// Update the URL.
				if (resNumber === 0) {
					this.set('measurement', res.response.id);
					this.set('_measurementOgTitle', measurementTitle);
					this.set('testReqParams.id', res.response.id);
				} else {
					app.router.replaceQueryParam('measurement', `${this.get('measurement').split('.').slice(-9).join('.')}.${res.response.id}`);
				}

				this.set(`measurementsMetadata[${resNumber}]`, {
					target,
					measurementId: res.response.id,
				});

				let updReqParams = {
					...reqParams,
					locations: res.response.id,
				};

				this.getTestMeasurementById({ measurementId: res.response.id, resNumber, isInfiniteMeas, reqParams: updReqParams, testRunId });
				this.set('showMap', this.get('originalShowMap'));
			}).catch((err) => {
				if (!this.isActiveTestRun(testRunId)) {
					return;
				}

				if (resNumber === 0) {
					this.set('measurement', null);
					this.set('_measurementOgTitle', null);
				}

				this.handlePostGPMeasError(err);
			});
		},
		isInfiniteOptsCorrect () {
			let { type, target } = this.get('mainOptions');

			return type === 'ping' && target.split(',').length <= 1;
		},
		handleInfiniteSwitch () {
			if (this.get('testInProgress') || !this.isInfiniteOptsCorrect()) { return; }

			let infiniteSwitchEnabled = this.get('infiniteSwitchEnabled');

			if (infiniteSwitchEnabled) {
				this.set('notAppliedOpts.packets', '');
			} else {
				this.set('notAppliedOpts.packets', INFINITE_MEASUREMENT_PACKETS);
			}

			this.set('infiniteSwitchEnabled', !infiniteSwitchEnabled);
			this.applyOptions();
		},
		handleInfiniteSwitchKeyDown (e) {
			if (e.key === 'Enter') {
				this.handleInfiniteSwitch();
			}
		},
		handlePostGPMeasError (err, isSecondTarget = false) {
			let isInfiniteModeRes = this.get('isInfiniteModeRes');
			let testResults = this.get('testResults');
			let targetsArr = this.get('targetsArr');

			this.set('testInProgress', false);
			this.enableRunTestBtn();
			// we show the error block under the map block only if it is not an infinite measurement or the one with no results
			this.set('runTestBtnText', 'Run Test');
			// set response headers (from error) for gp-credits/gp-credits-message
			this.set('rateCreditsData', err.responseHeaders);

			if (err.responseStatusCode === 429) {
				let measurementErrMsg = _.createMeasCreditsErrMsg(
					err.responseHeaders,
					this.get('@shared.user'),
					isInfiniteModeRes,
					!!testResults,
					isSecondTarget,
					targetsArr[0],
				);

				this.set('measurementErrMsg', measurementErrMsg);

				if (testResults && (isSecondTarget || isInfiniteModeRes)) {
					this.set('showCreditsErrorBar', true);
				} else {
					this.set('showCreditsData', false);
					this.set('showMap', false);
				}
			} else if (err.error.type === 'validation_error') {
				let measurementOptsErr = Object.keys(err.error.params || {}).some(key => key.split('.')[0] === 'measurementOptions');
				let inputErrors = _.parseValidationErrors(err.error, isSecondTarget && targetsArr[1]);

				this.set('inputErrors', inputErrors);

				// open measurement options menu if it contains errors
				if (measurementOptsErr) {
					this.set('showMeasurementOpts', true);
				}
			} else {
				this.set('measurementErrMsg', err.error.message);
				this.set('showMap', false);
			}
		},
		reUseProbesRunTest () {
			let prevProbesMeasId = this.get('prevProbesMeasId');

			this.resetMapAndRunTest(prevProbesMeasId);
		},
		handleDropDownRunTestBtnNav () {
			// set this handler only once
			if (this.get('ddHandlerSet')) { return; }

			setTimeout(() => {
				let dropdownComponent = document.getElementById('dd-run-test-btn');

				dropdownComponent.addEventListener('focusout', (event) => {
					let dropdownMenu = dropdownComponent.querySelector('.dropdown-menu');
					let button = dropdownComponent.querySelector('.dropdown-toggle');
					let buttonWrapper = dropdownComponent.querySelector('.gp_map-block_settings-wrapper_split-btn');

					if (dropdownMenu && event.relatedTarget && !dropdownMenu.contains(event.relatedTarget)) {
						dropdownMenu.querySelectorAll('.dropdown-item').forEach(item => item.classList.remove('active'));
						button.setAttribute('aria-expanded', false);
						buttonWrapper.classList.remove('open');
					}
				});

				dropdownComponent.addEventListener('keydown', (event) => {
					let dropdownMenu = dropdownComponent.querySelector('.dropdown-menu');
					let activeItem = dropdownComponent.querySelector('.dropdown-item.active');
					let button = dropdownComponent.querySelector('.dropdown-toggle');

					if (dropdownMenu) {
						if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
							if (!activeItem) {
								let firstItem = dropdownMenu.firstElementChild;

								if (firstItem) {
									firstItem.classList.add('active');
								}
							} else {
								let nextItem;

								if (event.key === 'ArrowDown') {
									nextItem = activeItem.nextElementSibling;
								} else if (event.key === 'ArrowUp') {
									nextItem = activeItem.previousElementSibling;
								}

								if (nextItem) {
									activeItem.classList.remove('active');

									nextItem.classList.add('active');
								} else if (event.key === 'ArrowUp') {
									activeItem.classList.remove('active');
									button.focus();
								}
							}
						} else if (event.key === 'Enter' && activeItem) {
							activeItem.click();
						}
					}
				});

				this.set('ddHandlerSet', true);
			}, 4);
		},
		createMapMarkerSvg (markerData) {
			let svg;
			let svgFillColors = [];
			let targetsCnt = this.get('targetsArr').length;
			let probesMaxTiming = this.get('probesMaxTiming');
			let probesMinTiming = this.get('probesMinTiming');

			for (let i = 0; i < targetsCnt; i++) {
				svgFillColors.push(markerData.timings[i]
					? _.getGpProbeStatusColor(markerData.timings[i], probesMaxTiming, probesMinTiming)
					: DEFAULT_MARKER_COLOR);
			}

			if (markerData.timings.length > 1) {
				svg = window.btoa(`<svg width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" viewBox="0 0 ${DEFAULT_MARKER_DIMENSIONS} ${DEFAULT_MARKER_DIMENSIONS}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[1]}"/>
					<clipPath id="cut-off">
					<rect x="6" y="4" width="6" height="1112"/>
					</clipPath>
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[0]}" clip-path="url(#cut-off)"/>
					<circle cx="12" cy="10" r="7" stroke="white" stroke-width="2"/>
					</g>
					<defs>
					<filter id="filter0_d_6106_3045" x="0" y="0" width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="2"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
					</filter>
					</defs>
					</svg>`);
			} else {
				svg = window.btoa(`<svg width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" viewBox="0 0 ${DEFAULT_MARKER_DIMENSIONS} ${DEFAULT_MARKER_DIMENSIONS}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
					<circle cx="12" cy="10" r="6" fill="${svgFillColors[0]}"/>
					<circle cx="12" cy="10" r="7" stroke="white" stroke-width="2"/>
					</g>
					<defs>
					<filter id="filter0_d_6106_3045" x="0" y="0" width="${DEFAULT_MARKER_DIMENSIONS}" height="${DEFAULT_MARKER_DIMENSIONS}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
					<feOffset dy="2"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
					</filter>
					</defs>
					</svg>`);
			}

			return svg;
		},
		createInfoWindowContent (markerData, currentMarkerIdx) {
			let targetsCnt = this.get('targetsArr').length;
			let probesMaxTiming = this.get('probesMaxTiming');
			let probesMinTiming = this.get('probesMinTiming');
			let infoWindowContent = '<div class="gp-map_popup">';

			infoWindowContent += `<div class="gp-map_popup${targetsCnt > 1 ? '_multi' : '_single'}">`;

			if (targetsCnt === 1) {
				infoWindowContent += `<div class="gp-map_popup_single_timing">${this.getMarkerTimingText(
					markerData.timings[0],
					markerData.errorCodes?.[0],
					markerData.failureSources?.[0],
					markerData.isInProgress?.[0],
				)}</div>`;

				infoWindowContent += `<div class="gp-map_popup_single_network">${markerData.network}</div>`;
				infoWindowContent += `<div class="gp-map_popup_single_location">(${markerData.city}, ${markerData.country})</div>`;
			} else {
				infoWindowContent += `<div class="gp-map_popup_multi_network">${markerData.network}</div>`;
				infoWindowContent += `<div class="gp-map_popup_multi_location">(${markerData.city}, ${markerData.country})</div>`;

				markerData.targets.forEach((target, targetIdx) => {
					infoWindowContent += '<div class="gp-map_popup_multi_data">';
					infoWindowContent += `<span class="gp-map_popup_multi_data_target">${target}</span>`;

					infoWindowContent += `<span class="gp-map_popup_multi_data_timing"
						style='color: ${_.getGpProbeStatusColor(markerData.timings[targetIdx], probesMaxTiming, probesMinTiming)}'>${this.getMarkerTimingText(
							markerData.timings[targetIdx],
							markerData.errorCodes?.[targetIdx],
							markerData.failureSources?.[targetIdx],
							markerData.isInProgress?.[targetIdx],
						)}</span>`;

					infoWindowContent += '</div>';
				});
			}

			infoWindowContent += '</div>';
			infoWindowContent += `<div class="gp-map_popup_see-results ${targetsCnt > 1 ? 'centered' : ''}" id="iw-${currentMarkerIdx}">`;
			infoWindowContent += `<img width="20" height="20" src="${this.get('@shared.assetsHost')}/img/see-results-icon.svg">`;
			infoWindowContent += '<span>Results and Actions</span>';
			infoWindowContent += '</div>';
			infoWindowContent += '</div>';

			return infoWindowContent;
		},
		getMarkerTimingText (timing, errorCode, failureSource, isInProgress) {
			if (this.get('isTestStopped') && isInProgress && !timing) {
				return 'Stopped';
			}

			if (timing === PROBE_STATUS_FAILED) {
				return _.getGpFailureStatusText(failureSource);
			}

			if (timing === PROBE_STATUS_OFFLINE) {
				return PROBE_OFFLINE_TEXT;
			}

			if (errorCode) {
				return errorCode;
			}

			return timing === PROBE_NO_TIMING_VALUE ? 'Timed out' : _.capitalizeFirstLetter(timing);
		},
		isDnsTraceEnabled () {
			let testReqParams = this.get('testReqParams');

			return testReqParams
				? testReqParams.measurementOptions?.trace === true
				: this.get('dnsOpts.trace') === true;
		},
		getTableColumns (testType = this.get('testReqParams.type'), dnsTraceEnabled) {
			let lowCaseTestName = (testType || '').toLowerCase();

			if (typeof dnsTraceEnabled !== 'boolean') {
				dnsTraceEnabled = this.isDnsTraceEnabled();
			}

			let cacheKey = `${lowCaseTestName}:${dnsTraceEnabled}`;
			let cachedColumns = TABLE_COLUMNS_CACHE.get(cacheKey);

			if (cachedColumns) {
				return cachedColumns;
			}

			let rttTimings = [
				{ key: 'rtt-last', label: 'rtt last', mobileLabel: 'Rtt last' },
				{ key: 'min', label: 'min', mobileLabel: 'Rtt min' },
				{ key: 'avg', label: 'avg', mobileLabel: 'Rtt avg' },
				{ key: 'max', label: 'max', mobileLabel: 'Rtt max' },
			];

			let timingColumn = timings => ({
				key: 'timings',
				type: 'timings',
				className: 'rtt',
				timings: timings.map((timing, idx) => ({
					isLast: idx === timings.length - 1,
					...timing,
				})),
			});
			let tableColumns;

			if ([ 'traceroute', 'mtr' ].includes(lowCaseTestName)) {
				tableColumns = [
					{ key: 'hops', label: 'Hops', className: 'hops' },
					timingColumn(rttTimings),
					{ key: 'ip', type: 'ip', label: 'Resolved IP', mobileLabel: 'IP', className: 'ip', sortable: false },
					{ key: 'graph', type: 'graph', label: 'Graph', className: 'graph', sortable: false },
				];
			} else if (lowCaseTestName === 'dns') {
				tableColumns = [
					...dnsTraceEnabled
						? [{ key: 'answers', type: 'dns-answers', label: 'Answers', sortName: 'Answer count', className: 'answers' }]
						: [{ key: 'dns-status', type: 'dns-response', label: 'Response', className: 'answers dns-response' }],
					{ key: 'total', label: 'Time', className: 'total' },
					{ key: 'resolver', label: 'Resolver', className: 'resolver', sortable: false },
				];
			} else if (lowCaseTestName === 'http') {
				tableColumns = [
					{ key: 'http-status', label: 'Status', className: 'status http-status' },
					{ key: 'content-length', label: 'Content length', className: 'content-length' },
					{ key: 'total', label: 'Total', className: 'total' },
					{ key: 'ip', type: 'ip', label: 'Resolved IP', mobileLabel: 'IP', className: 'ip', sortable: false },
				];
			} else if (lowCaseTestName === 'ping') {
				tableColumns = [
					{ key: 'quality', label: 'Quality', className: 'quality' },
					timingColumn(rttTimings),
					{ key: 'ip', type: 'ip', label: 'Resolved IP', mobileLabel: 'IP', className: 'ip', sortable: false },
					{ key: 'graph', type: 'graph', label: 'Graph', className: 'graph', sortable: false },
				];
			} else {
				throw new Error(`Unsupported table test type: ${testType}`);
			}

			TABLE_COLUMNS_CACHE.set(cacheKey, tableColumns);

			return tableColumns;
		},
		getSortOptionsFromTableColumns (tableColumns) {
			let options = [{ value: 'location', name: 'Location' }];

			tableColumns.forEach((column) => {
				if (column.type === 'timings') {
					column.timings
						.filter(timing => timing.sortable !== false)
						.forEach(timing => options.push({ value: timing.key, name: timing.mobileLabel || timing.label }));

					return;
				}

				if (column.sortable !== false) {
					options.push({ value: column.key, name: column.sortName || column.label });
				}
			});

			return options;
		},
		getAllTableSortValues () {
			let values = new Set();

			MEASUREMENT_TYPES.forEach((testType) => {
				let dnsTraceVariants = testType === 'dns' ? [ false, true ] : [ false ];

				dnsTraceVariants.forEach((dnsTraceEnabled) => {
					this.getSortOptionsFromTableColumns(this.getTableColumns(testType, dnsTraceEnabled))
						.forEach(option => values.add(option.value));
				});
			});

			return [ ...values ];
		},
		hasTableValue (value) {
			return value !== null && typeof value !== 'undefined' && value !== '';
		},
		createMetricTableCell (value) {
			return {
				value,
				hasValue: this.hasTableValue(value),
			};
		},
		createTimingTableCell (column, valuesByKey) {
			let timings = column.timings.map((timing) => {
				let value = valuesByKey[timing.key];

				return {
					value,
					hasValue: this.hasTableValue(value),
					units: typeof value === 'number' ? 'ms' : '',
				};
			});

			return {
				timings,
				showDesktopUnits: timings.length > 0 && timings.every(timing => typeof timing.value === 'number'),
			};
		},
		createEmptyTableCells (testType, dnsTraceEnabled) {
			return this.getTableColumns(testType, dnsTraceEnabled).map((column) => {
				if (column.type === 'timings') {
					return this.createTimingTableCell(column, {});
				}

				return this.createMetricTableCell(null);
			});
		},
		getLastHop (result = {}) {
			let hops = result.hops || [];

			return hops.length ? hops[hops.length - 1] : null;
		},
		getLastHopRtts (result = {}) {
			let lastHop = this.getLastHop(result);
			let timings = lastHop?.timings || [];

			if (timings.length) {
				return timings.map((timing) => {
					return typeof timing?.rtt === 'number' && Number.isFinite(timing.rtt)
						? timing.rtt
						: PROBE_NO_TIMING_VALUE;
				});
			}

			let packetsTotal = lastHop?.stats?.total;

			if (!Number.isInteger(packetsTotal) || packetsTotal < 0) {
				packetsTotal = Math.max(0, ...(result.hops || []).map(hop => hop.timings?.length || 0));
			}

			return Array(packetsTotal).fill(PROBE_NO_TIMING_VALUE);
		},
		getLastHopTimingStats (result = {}) {
			let rtts = this.getLastHopRtts(result);
			let numericRtts = rtts.filter(rtt => typeof rtt === 'number' && Number.isFinite(rtt));

			if (!numericRtts.length) {
				return {
					last: rtts[rtts.length - 1] ?? null,
					min: PROBE_NO_TIMING_VALUE,
					avg: PROBE_NO_TIMING_VALUE,
					max: PROBE_NO_TIMING_VALUE,
				};
			}

			let total = numericRtts.reduce((sum, rtt) => sum + rtt, 0);

			return {
				last: numericRtts[numericRtts.length - 1],
				min: Math.min(...numericRtts),
				avg: total / numericRtts.length,
				max: Math.max(...numericRtts),
			};
		},
		getLastHopLastTiming (result = {}) {
			let rtts = this.getLastHopRtts(result);

			for (let i = rtts.length - 1; i >= 0; i--) {
				if (typeof rtts[i] === 'number') {
					return rtts[i];
				}
			}

			return rtts[rtts.length - 1] ?? null;
		},
		getHttpStatusText (result = {}) {
			let { statusCode, statusCodeName } = result;

			if (this.hasTableValue(statusCode) && this.hasTableValue(statusCodeName)) {
				return `${statusCode} ${statusCodeName}`;
			}

			return this.hasTableValue(statusCode) ? statusCode : statusCodeName;
		},
		getHeaderValue (headers = {}, headerName) {
			let headerKey = Object.keys(headers || {}).find(key => key.toLowerCase() === headerName.toLowerCase());

			return headerKey ? headers[headerKey] : null;
		},
		getHttpContentLength (result = {}) {
			let contentLength = this.getHeaderValue(result.headers, 'content-length');

			if (typeof contentLength === 'number' && Number.isFinite(contentLength)) {
				return contentLength;
			}

			if (typeof contentLength === 'string' && /^\d+$/.test(contentLength.trim())) {
				return Number(contentLength.trim());
			}

			return null;
		},
		createTableDataForTarget (testType, res, targetStats, dnsTraceEnabled) {
			let lowCaseTestName = (testType || '').toLowerCase();
			let tableColumns = this.getTableColumns(testType, dnsTraceEnabled);
			let sortValues = {};
			let tableCells;

			if (lowCaseTestName === 'ping') {
				tableCells = tableColumns.map((column) => {
					if (column.key === 'quality') {
						return this.createMetricTableCell(targetStats.qualityStr);
					}

					if (column.type === 'timings') {
						let values = targetStats.areTimingsReady ? {
							'rtt-last': targetStats.lastTiming,
							'min': targetStats.minTiming,
							'avg': targetStats.avgTiming,
							'max': targetStats.maxTiming,
						} : {};

						sortValues['rtt-last'] = targetStats.lastTiming;
						sortValues.min = targetStats.minTiming;
						sortValues.avg = targetStats.avgTiming;
						sortValues.max = targetStats.maxTiming;

						return this.createTimingTableCell(column, values);
					}

					if (column.key === 'ip') {
						return this.createMetricTableCell(targetStats.ipAddr);
					}

					return this.createMetricTableCell(targetStats.packetsRtt);
				});
			} else if ([ 'traceroute', 'mtr' ].includes(lowCaseTestName)) {
				let hops = res.result?.hops?.length ?? 0;
				let timingValues = {
					'rtt-last': targetStats.lastTiming,
					'min': targetStats.minTiming,
					'avg': targetStats.avgTiming,
					'max': targetStats.maxTiming,
				};

				sortValues = { ...timingValues, hops };

				tableCells = tableColumns.map((column) => {
					if (column.key === 'hops') {
						return this.createMetricTableCell(hops);
					}

					if (column.type === 'timings') {
						return this.createTimingTableCell(column, timingValues);
					}

					if (column.key === 'ip') {
						return this.createMetricTableCell(targetStats.ipAddr);
					}

					return this.createMetricTableCell(targetStats.packetsRtt);
				});
			} else if (lowCaseTestName === 'dns') {
				let dnsResult = dnsTraceEnabled ? this.getLastHop(res.result) || res.result : res.result;
				let statusText = dnsResult.statusCodeName ?? dnsResult.statusCode;
				let answers = (dnsResult.answers || []).filter(answer => answer && [ 'name', 'ttl', 'type', 'value' ]
					.every(key => this.hasTableValue(answer[key])));
				let total = dnsResult.timings?.total;
				let resolver = dnsResult.resolver;
				let answerValues = answers.map(answer => ({
					name: answer.name,
					ttl: answer.ttl,
					type: answer.type,
					value: answer.value,
				}));

				sortValues['dns-status'] = typeof dnsResult.statusCode === 'number' ? dnsResult.statusCode : statusText;
				sortValues.answers = answers.length;
				sortValues.total = total;

				tableCells = tableColumns.map((column) => {
					if (column.type === 'dns-response') {
						return {
							value: answerValues,
							hasValue: answers.length > 0,
							status: statusText,
							hasStatus: this.hasTableValue(statusText),
						};
					}

					if (column.type === 'dns-answers') {
						return {
							value: answerValues,
							hasValue: answers.length > 0,
						};
					}

					if (column.key === 'total') {
						return this.createMetricTableCell(typeof total === 'number' ? `${total} ms` : null);
					}

					return this.createMetricTableCell(resolver);
				});
			} else if (lowCaseTestName === 'http') {
				let statusText = this.getHttpStatusText(res.result);
				let total = res.result?.timings?.total;
				let contentLength = this.getHttpContentLength(res.result);

				sortValues['http-status'] = res.result?.statusCode;
				sortValues.total = total;
				sortValues['content-length'] = contentLength;

				tableCells = tableColumns.map((column) => {
					if (column.key === 'http-status') {
						return this.createMetricTableCell(statusText);
					}

					if (column.key === 'total') {
						return this.createMetricTableCell(typeof total === 'number' ? `${total} ms` : null);
					}

					if (column.key === 'ip') {
						return this.createMetricTableCell(targetStats.ipAddr);
					}

					return this.createMetricTableCell(typeof contentLength === 'number' ? `${contentLength} B` : null);
				});
			} else {
				tableCells = this.createEmptyTableCells(testType, dnsTraceEnabled);
			}

			return {
				tableCells,
				sortValues,
			};
		},
		prepareRegularResults (testResults) {
			if (!testResults || testResults.length === 0) {
				return [];
			}

			let dnsTraceEnabled = this.isDnsTraceEnabled();

			let parseTargetStats = (res) => {
				let baseStat = {
					target: res.target,
					isInProgress: res.result.status === 'in-progress',
				};

				if (res.result.status === 'in-progress') {
					return {
						...baseStat,
						tableCells: this.createEmptyTableCells(res.type, dnsTraceEnabled),
						sortValues: {},
					};
				}

				let {
					isFailed = false,
					lastTiming,
					value: avgTiming,
					extraValues,
				} = _.calcGpTestResTiming(res.type, res, dnsTraceEnabled);

				let { packetsRtt, packetsTotal } = _.parseGpRawOutputForTimings(res.result.rawOutput);

				if ([ 'traceroute', 'mtr' ].includes(res.type)) {
					packetsRtt = this.getLastHopRtts(res.result);
				}

				let stats = res.result?.stats || {};
				let isOffline = res.result.status === PROBE_STATUS_OFFLINE;
				let minTiming = typeof stats.min === 'number' ? stats.min : PROBE_NO_TIMING_VALUE;
				let maxTiming = typeof stats.max === 'number' ? stats.max : PROBE_NO_TIMING_VALUE;

				let rawOutput = res.result.rawOutput || '';
				let rawBody = null;
				let rawHeaders = rawOutput;

				if (res.type === 'http') {
					({ rawBody, rawHeaders } = _.extractHttpRawOutput(rawOutput));
				}

				if (res.type === 'traceroute') {
					let lastHopTimingStats = this.getLastHopTimingStats(res.result);

					lastTiming = lastHopTimingStats.last;
					minTiming = lastHopTimingStats.min;
					avgTiming = lastHopTimingStats.avg;
					maxTiming = lastHopTimingStats.max;
				}

				if (res.type === 'mtr') {
					let lastHopStats = this.getLastHop(res.result)?.stats || {};

					lastTiming = this.getLastHopLastTiming(res.result);
					minTiming = typeof lastHopStats.min === 'number' ? lastHopStats.min : PROBE_NO_TIMING_VALUE;
					maxTiming = typeof lastHopStats.max === 'number' ? lastHopStats.max : PROBE_NO_TIMING_VALUE;
				}

				let targetStats = {
					...baseStat,
					ipAddr: res.result.resolvedAddress,
					lastTiming,
					minTiming,
					avgTiming,
					maxTiming,
					statsTotal: stats.total,
					statsDrop: stats.drop,
					isFailed,
					isOffline,
					packetsRtt,
					extraValues,
					failureSource: res.result.failureSource,
					failureRawOutput: this.getFailureProbeRawOutput(res),
					rawOutput: rawHeaders,
					responseBody: rawBody,
					qualityStr: this.createQualityString(isOffline, stats.total, stats.drop),
					areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotal),
					tls: res.result.tls,
				};
				let tableData = this.createTableDataForTarget(res.type, res, targetStats, dnsTraceEnabled);

				return {
					...targetStats,
					...tableData,
				};
			};

			let prepResults = testResults[0].map(res => ({
				clientSideId: res.clientSideId,
				...res.probe,
				statsPerTarget: [ parseTargetStats(res) ],
			}));

			for (let i = 1; i < testResults.length; i++) {
				prepResults.forEach((pR) => {
					let nextRes = testResults[i].find(r => r.clientSideId === pR.clientSideId);

					if (nextRes) {
						pR.statsPerTarget.push(parseTargetStats(nextRes));
					}
				});
			}

			return prepResults;
		},
		prepareInfiniteResults (rawResults) {
			let probesAmount = rawResults[0].length;
			let probesMeasurements = [];

			// gather probe's data from different measurements, with each sub array representing a single probe's data
			for (let i = 0; i < probesAmount; i++) {
				probesMeasurements.push(rawResults.map(rr => rr[i]));
			}

			// prepare data for gp-raw-output, gp-table-output components
			return probesMeasurements.map((pbm) => {
				return pbm.reduce((combinedProbeData, probeData) => {
					let { packetsRtt, packetsDrop, packetsTotal } = _.parseGpRawOutputForTimings(probeData.result.rawOutput);
					let isOffline = probeData.result.status === PROBE_STATUS_OFFLINE;
					let packetsRttCombined = [ ...combinedProbeData.packetsRtt || [], ...packetsRtt ];
					let packetsDropCombined = (combinedProbeData.packetsDrop || 0) + packetsDrop;
					let packetsTotalCombined = (combinedProbeData.packetsTotal || 0) + packetsTotal;
					let numericPacketsRttCombined = packetsRttCombined.filter(v => typeof v === 'number');
					let maxTiming = numericPacketsRttCombined.length ? Math.max(...numericPacketsRttCombined) : PROBE_NO_TIMING_VALUE;
					let minTiming = numericPacketsRttCombined.length ? Math.min(...numericPacketsRttCombined) : PROBE_NO_TIMING_VALUE;
					let avgTiming = numericPacketsRttCombined.length
						? Number((numericPacketsRttCombined.reduce((res, rtt) => res += rtt, 0) / numericPacketsRttCombined.length).toFixed(2))
						: PROBE_NO_TIMING_VALUE;
					let lastTiming = packetsRttCombined[packetsRttCombined.length - 1] || PROBE_NO_TIMING_VALUE;
					let lossValue = this.calcLoss(packetsRttCombined.length + packetsDropCombined, packetsDropCombined);
					let { packetLines, linesHeader, lastLineIdx } = this.parseLinesFromRawOutput(
						probeData.result.rawOutput,
						combinedProbeData.lastLineIdx || 0,
					);
					let outputLinesCombined = [ ...combinedProbeData.rawOutputLines || [], ...packetLines ];
					let ipAddr = combinedProbeData.ipAddr || this.parseIPFromRawOutput(probeData.result.rawOutput);
					let rawOutputCombined = this.handleRawOutput([ linesHeader, ...outputLinesCombined ]);
					let clientSideMeasTime = probeData.clientSideUpdatedAt - probeData.clientSideStartedAt;
					let measurementTimeCombined = combinedProbeData.measurementTime || 0;

					// if measurement is finished we should take a server time (updatedAt - createdAt)
					if (probeData.status === 'finished') {
						measurementTimeCombined += probeData.serverTime;
					} else {
						// otherwise we should take a local time
						measurementTimeCombined += clientSideMeasTime;
					}

					let targetStats = {
						target: probeData.target,
						ipAddr,
						lastTiming,
						minTiming,
						avgTiming,
						maxTiming,
						statsTotal: packetsRttCombined.length,
						statsDrop: packetsDropCombined,
						isInProgress: probeData.result.status === 'in-progress',
						isFailed: probeData.result.status === PROBE_STATUS_FAILED,
						isOffline,
						failureSource: probeData.result.failureSource,
						failureRawOutput: this.getFailureProbeRawOutput(probeData),
						packetsRtt: packetsRttCombined,
						qualityStr: this.createQualityString(isOffline, numericPacketsRttCombined.length + packetsDropCombined, packetsDropCombined),
						areTimingsReady: this.checkAreTimingsReady(lastTiming, maxTiming, minTiming, avgTiming, packetsTotalCombined),
						rawOutput: rawOutputCombined,
						extraValues: lossValue !== null ? { loss: { text: 'Loss', value: lossValue, units: '%' } } : {},
						rawFooter: this.createRawFooter(
							probeData.target,
							numericPacketsRttCombined,
							packetsTotalCombined,
							numericPacketsRttCombined.length,
							lossValue,
							minTiming,
							avgTiming,
							maxTiming,
							measurementTimeCombined,
							rawOutputCombined,
						),
					};

					return {
						...combinedProbeData,
						lastLineIdx,
						packetsRtt: packetsRttCombined,
						packetsDrop: packetsDropCombined,
						packetsTotal: packetsTotalCombined,
						rawOutputLines: outputLinesCombined,
						measurementTime: measurementTimeCombined,
						ipAddr,
						clientSideId: probeData.clientSideId,
						...probeData.probe,
						statsPerTarget: [{
							...targetStats,
							...this.createTableDataForTarget('ping', probeData, targetStats),
						}],
					};
				}, {});
			});
		},
		getFailureProbeRawOutput (probeData) {
			let rawOutput;
			let { status = null } = probeData.result;

			if (status === PROBE_STATUS_OFFLINE || status === PROBE_STATUS_FAILED) {
				rawOutput = probeData.result.rawOutput;
			}

			return rawOutput;
		},
		createQualityString (isOffline, statsTotal, statsDrop) {
			if (isOffline) { return PROBE_OFFLINE_TEXT; }

			let { actualAmount, qualityPercentage } = this.calcQuality(statsTotal, statsDrop);

			return qualityPercentage !== null ? `${actualAmount}/${statsTotal} - ${qualityPercentage}%` : '';
		},
		checkAreTimingsReady (lastTiming, maxTiming, minTiming, avgTiming, packetsTotal) {
			if (
				!packetsTotal
				|| typeof lastTiming === 'undefined'
				|| typeof maxTiming === 'undefined'
				|| typeof minTiming === 'undefined'
				|| typeof avgTiming === 'undefined'
			) {
				return false;
			}

			return true;
		},
		calcQuality (statsTotal, statsDrop) {
			if (
				typeof statsTotal === 'undefined'
				|| typeof statsDrop === 'undefined'
				|| statsTotal === 0
			) {
				return {
					qualityPercentage: null,
					actualAmount: null,
				};
			}

			let actualAmount = Math.max(statsTotal - statsDrop, 0);
			let qualityPercentage = Math.round(actualAmount / statsTotal * 100);

			return {
				qualityPercentage,
				actualAmount,
			};
		},
		parseIPFromRawOutput (raw) {
			let regex = ipRegex();
			let match = raw.match(regex);

			if (match) {
				return match[0];
			}

			return '';
		},
		parseLinesFromRawOutput (raw, idxShift = 0) {
			let lines = raw.split('\n').filter(l => l);
			let linesHeader;
			let packetLines = [];
			let lastLineIdx = idxShift;

			for (let i = 0; i < lines.length; i++) {
				if (i === 0) {
					linesHeader = lines[i];

					continue;
				}

				if (lines[i].includes('---')) { break; }

				let subRegex = /(icmp_seq|tcp_conn)=(\d+)/;
				let match = lines[i].match(subRegex);
				let proto = match[1];
				let originalIdx = Number(match[2]);
				lastLineIdx = idxShift + originalIdx;
				let substitute = `${proto}=${lastLineIdx}`;
				let numberedLine = lines[i].replace(subRegex, substitute);

				packetLines.push(numberedLine);
			}

			return {
				packetLines,
				linesHeader,
				lastLineIdx,
			};
		},
		calcLoss (statsTotal, statsDrop) {
			if (
				typeof statsTotal === 'undefined'
				|| typeof statsDrop === 'undefined'
				|| statsTotal === 0
			) {
				return null;
			}

			let actualAmount = Math.max(statsTotal - statsDrop, 0);

			return Math.round(statsDrop / actualAmount * 100);
		},
		handleRawOutput (lines) {
			let limitedLines = lines.length > RAW_OUTPUT_LINES_BATCH_LIMIT ? [ '...', ...lines.slice(-RAW_OUTPUT_LINES_BATCH_LIMIT) ] : lines;

			return limitedLines.join('\n');
		},
		setMainOptsTestType (newTestType) {
			if (this.get('testInProgress')) { return; }

			this.set('mainOptions.type', newTestType);
		},
		createRawFooter (
			target,
			rtts,
			packetsTotal,
			packetsReceived,
			lossValue,
			minTiming,
			avgTiming,
			maxTiming,
			time,
			rawOutput = '',
		) {
			let mdev = this.calculateMeanDeviation(rtts);
			let showRttUnits = [ minTiming, avgTiming, maxTiming, mdev ].some(i => i !== PROBE_NO_TIMING_VALUE);
			let str = `${rawOutput ? '\n' : ''}--- ${target} ping statistics ---
${packetsTotal} packets transmitted, ${packetsReceived} received, ${lossValue || 0}% packet loss, time ${time}ms
rtt min/avg/max/mdev = ${minTiming}/${avgTiming}/${maxTiming}/${mdev}${showRttUnits ? ' ms' : ''}`;

			return str;
		},
		calculateMeanDeviation (rtts) {
			if (rtts.length === 0) {
				return PROBE_NO_TIMING_VALUE;
			}

			let rttsNumber = rtts.length;
			let rttsSquaredSum = rtts.reduce((sum, rtt) => sum + rtt * rtt, 0);
			let rttsSum = rtts.reduce((sum, rtt) => sum + rtt, 0);
			let mdev = Math.sqrt(rttsSquaredSum / rttsNumber - Math.pow(rttsSum / rttsNumber, 2));

			return Math.round(mdev * 1000) / 1000;
		},
		groupProbes (probes) {
			// group probes by Continents and Coordinates
			let groups = probes.reduce((res, probe) => {
				let coords = `${probe.location.latitude}, ${probe.location.longitude}`;

				// group by Coordinates
				if (!Object.hasOwn(res, coords)) {
					res[coords] = [];
				}

				res[coords].push(probe);

				return res;
			}, {});

			return groups;
		},
		createMapClusterMarkerWithIW (key, markersByCoords) {
			let [ lat, lng ] = key.split(', ');
			let svg = this.createClusterMarkerSVG(markersByCoords.length);
			let probeInfoWindow = new google.maps.InfoWindow();

			// Collect InfoWindows
			probesInfoWindows.push(probeInfoWindow);
			probeInfoWindow.setContent(this.createClusterMarkerInfoWindowContent(markersByCoords));

			let markerContent = document.createElement('div');
			markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
			markerContent.style.backgroundRepeat = 'no-repeat';
			markerContent.style.backgroundPosition = 'center';
			markerContent.style.backgroundSize = 'contain';
			markerContent.setAttribute('data-probe-count', markersByCoords.length);

			let { svgWidth, svgHeight } = getMarkerSize(markersByCoords.length, map.zoom);
			markerContent.style.width = `${svgWidth}px`;
			markerContent.style.height = `${svgHeight}px`;

			let probeMarker = new google.maps.marker.AdvancedMarkerElement({
				content: markerContent,
				position: { lat: Number(lat), lng: Number(lng) },
				zIndex: 1,
			});

			probeMarker.addListener('click', () => {
				probesInfoWindows.forEach(iw => iw.close());
				probeInfoWindow.open({ map, anchor: probeMarker });
			});

			probeMarker.markersCount = markersByCoords.length || 0;

			return probeMarker;
		},
		createClusterMarkerInfoWindowContent (markersByCoords) {
			let markersCnt = markersByCoords.length;
			let groupedNetworks = markersByCoords.reduce((res, m) => {
				let marker = res.find(i => i.location.network === m.location.network);

				if (marker) {
					marker.cnt += 1;
				} else {
					res.push({ ...m, cnt: 1, sortKey: m.location.network.toLowerCase() });
				}

				return res;
			}, []).sort((a, b) => a.sortKey < b.sortKey ? -1 : a.sortKey > b.sortKey);

			let infoWindowContent = `<div class="gp_map-cluster-iw">`;

			if (markersCnt === 1) {
				let { network, city, country } = markersByCoords[0].location;

				infoWindowContent += `<span>${network} (${city}, ${country})</span>`;
			} else {
				// in this case we should render a list of probes
				groupedNetworks.forEach((m, mIdx) => {
					if (mIdx === 0) {
						// add header content
						infoWindowContent += '<span class="gp_map-cluster-iw_header">';
						infoWindowContent += `<img width="16" height="16" src="${this.get('@shared.assetsHost')}/img/location-icon.svg">`;
						infoWindowContent += `<span class="gp_map-cluster-iw_header_location">${m.location.city}, ${m.location.country}</span>`;
						infoWindowContent += `<span class="gp_map-cluster-iw_header_cnt">${markersByCoords.length}</span>`;
						infoWindowContent += '</span>';
					}

					// render the list of the probes, grouped by the same network
					infoWindowContent += `<span class="gp_map-cluster-iw_row">${m.location.network} ${m.cnt > 1 ? `<span class="gp_map-cluster-iw_row_network-cnt">${m.cnt}</span>` : ''}</span>`;
				});
			}

			infoWindowContent += '</div>';

			return infoWindowContent;
		},
		createClusterMarkerSVG (elementsCnt) {
			let { svgWidth, svgHeight, circleRadius, strokeWidth } = getMarkerSize(elementsCnt, 1); // here zoom must always be 1

			return window.btoa(`
				<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius}" fill="#17D4A7"/>
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius + 1}" stroke="white" stroke-width="${strokeWidth}"/>
					</g>
					${elementsCnt !== 1 ? `<text x="${svgWidth / 2}" y="${svgHeight / 2}" text-anchor="middle" dy=".35em" font-family="Arial" font-size="10" font-weight="bold" fill="#fff">${elementsCnt}</text>` : ''}
					<defs>
						<filter id="filter0_d_6106_3045" x="0" y="0" width="${svgWidth}" height="${svgHeight}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="1"/>
							<feGaussianBlur stdDeviation="1"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
						</filter>
					</defs>
				</svg>
			`);
		},
		spiderifyMapMarkers (clickedMarker, markers, map) {
			let projection = map.getProjection();
			let clickedPos = projection.fromLatLngToPoint(clickedMarker.position);
			let markerWidth = DEFAULT_MARKER_DIMENSIONS;
			let a = markerWidth;
			let b = 0.2 * markerWidth;
			let theta = 0;

			let overlappedMarkers = markers.filter((marker) => {
				if (marker === clickedMarker) { return false; }

				let markerPos = projection.fromLatLngToPoint(marker.position);
				let pixelDistance = Math.sqrt(Math.pow(clickedPos.x - markerPos.x, 2) + Math.pow(clickedPos.y - markerPos.y, 2)) * Math.pow(2, map.zoom);

				return pixelDistance <= markerWidth;
			});

			let spiderMarkers = [ clickedMarker, ...overlappedMarkers ];

			spiderMarkers.forEach((marker, index) => {
				marker.isSpiderPart = true;

				if (index === 0) {
					// keep the clicked marker in place
					marker.position = clickedMarker.position;
				} else {
					// spiral calculation
					let r = a + b * theta;
					let offsetX = r * Math.cos(theta);
					let offsetY = r * Math.sin(theta);
					let x = clickedPos.x + offsetX / Math.pow(2, map.zoom);
					let y = clickedPos.y + offsetY / Math.pow(2, map.zoom);
					let point = new google.maps.Point(x, y);
					let latLng = projection.fromPointToLatLng(point);

					marker.position = new google.maps.LatLng(latLng.lat(), latLng.lng());
					marker.zIndex = 99999;

					// increment angle
					theta += markerWidth / r;
				}
			});
		},
		despiderifyMapMarkers (markers) {
			markers.forEach((m) => {
				let originalPos = originalMapMarkersPos.get(m);

				if (originalPos) {
					m.position = originalPos;
					m.zIndex = 1;
					m.isSpiderPart = false;
				}
			});
		},
		shouldMapMarkersSpiderify (clickedMarker, markers, map) {
			let projection = map.getProjection();
			let clickedPos = projection.fromLatLngToPoint(clickedMarker.position);
			let overlapThreshold = DEFAULT_MARKER_DIMENSIONS / 2;

			return markers.some((marker) => {
				if (marker !== clickedMarker) {
					let markerPos = projection.fromLatLngToPoint(marker.position);
					let pixelDistance = Math.sqrt(Math.pow(clickedPos.x - markerPos.x, 2) + Math.pow(clickedPos.y - markerPos.y, 2)) * Math.pow(2, map.zoom);

					return pixelDistance <= overlapThreshold;
				}

				return false;
			});
		},
		resetMeasurementOptions (type) {
			type ||= this.get('mainOptions.type');
			this.set('showMeasurementOpts', false);
			this.set('inputErrors', {});
			this.set(`${type.toLowerCase()}Opts`, this.getDefaultClientMeasOptsByTestName(type));
			this.set('appliedMeasOpts', {});
			this.set('notAppliedOpts', {});
			this.set('measurementErrMsg', null);
			this.set('modifiedMeasOptsCnt', 0);
			this.set('infiniteSwitchEnabled', false);
		},
		onExampleClick (options) {
			let { extended, infinite, ...mainOptions } = options;

			this.resetMeasurementOptions(mainOptions.type);

			if (infinite) {
				this.set('infiniteSwitchEnabled', true);
				this.set('notAppliedOpts.packets', INFINITE_MEASUREMENT_PACKETS);
			}

			this.set('mainOptions', mainOptions);

			if (extended) {
				this.set(`${mainOptions.type}Opts`, extended);
			}

			this.applyOptions();
			this.resetMapAndRunTest();
			this.scrollMapIntoView();
		},
	};
</script>
